import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  ProjectState_InProgress_getInstance2qplvnabv8loq as ProjectState_InProgress_getInstance,
  UserRole_Admin_getInstance3u101dj1ubbhu as UserRole_Admin_getInstance,
  MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance,
  MemberRole_Employee_getInstance37kv78awnpbvk as MemberRole_Employee_getInstance,
  LineItemState_RequestingReview_getInstance2ojeopd3nid3v as LineItemState_RequestingReview_getInstance,
  LineItemState_NotApproved_getInstance1n0ztla6z4oyz as LineItemState_NotApproved_getInstance,
  ProjectState_Invited_getInstancendchtgzjx7u0 as ProjectState_Invited_getInstance,
  ProjectState_WaitingApproval_getInstance1ditr18fxhnoh as ProjectState_WaitingApproval_getInstance,
  ProjectState_Accepted_getInstance2l1kftynf92aa as ProjectState_Accepted_getInstance,
  ProjectState_SubstantialCompletion_getInstance3e5twdtenc1l1 as ProjectState_SubstantialCompletion_getInstance,
  ProjectState_RequestingComplete_getInstance29ba44myrjzuw as ProjectState_RequestingComplete_getInstance,
  ProjectState_Complete_getInstance2ov0hpwbwxocu as ProjectState_Complete_getInstance,
  Party_Client_getInstance1cdrz74lwe2vi as Party_Client_getInstance,
  PaymentState_AwaitingConfirmation_getInstance3vwisicrp8je as PaymentState_AwaitingConfirmation_getInstance,
  ProjectState_AwaitingFunding_getInstance2uhrgbgvubwqq as ProjectState_AwaitingFunding_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  color1u2lxyvdop1o6 as color,
  get_displayColor1gavqb36ugd6h as get_displayColor,
  DirectlyDisplayableStatebtdfi3611j0b as DirectlyDisplayableState,
} from '../../components/project/work/payApps/data.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_activity2bclxkea3doa as get_activity } from '../../../icons.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  Companion_getInstance33aui7uk8ap15 as Companion_getInstance_0,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  resize3py5p2yrjp6p7 as resize,
  truncate3gvhc1a2is66m as truncate,
  filterNullKeys1r8wmaox0efdd as filterNullKeys,
  interceptImmediateWrite9xa8d51e8bew as interceptImmediateWrite,
  equalToDynamic3go34vx15ysu8 as equalToDynamic,
} from '../../../utils/utils.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  captureStack1fzi4aczwc4hg as captureStack,
  equals2au1ep9vhcato as equals,
  boxApply1qmzdb3dh90hg as boxApply,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  _MonetaryValue___get_absoluteValue__impl__hjldkw3vj23mkf30f7c as _MonetaryValue___get_absoluteValue__impl__hjldkw,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  get_pending3bzoyvzwzq8kn as get_pending,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  toString30pk9tzaqopn as toString,
  arrayOf1akklvh2at202 as arrayOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import {
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
  get_session9cytjmfbg8nd as get_session,
} from '../../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
  rerunOn28vy04vs1j44i as rerunOn,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { get_selectedContractor2m4vxuqdzv6k3 as get_selectedContractor } from '../../../selectedContractor.mjs';
import { ClientProject3d3kef0q1hn13 as ClientProject } from '../client/ClientProject.mjs';
import { ContractorProject2o386x7rid4t as ContractorProject } from '../contractor/ContractorProject.mjs';
import { LogInScreen3qovz4fzwtjwv as LogInScreen } from '../auth/LogInScreen.mjs';
import { get_pageNavigator1inl9j7ja0vlf as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  BasicListenable3uz4a8xs34a0h as BasicListenable,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  LateInitSignal30crwrg540xyy as LateInitSignal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { ActivityIndicatork1oa7i2hevyv as ActivityIndicator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ActivityIndicator.commonHtml.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import {
  Exceptiondt2hlxn7j7vw as Exception,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { SealedClassSerializeriwipiibk55zc as SealedClassSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SealedSerializer.mjs';
import { ledger9gxuwjk9lhk4 as ledger } from '../../components/project/projectInfo/ledger.mjs';
import { projectDetails3emvwwschfdk7 as projectDetails } from '../../components/project/projectInfo/projectDetails.mjs';
import { contacts16kylqd85uusk as contacts } from '../../components/project/projectInfo/contacts.mjs';
import {
  projectToDos1k6no8sa36ugx as projectToDos,
  calculateTodos38oklz6cvum2 as calculateTodos,
} from '../../components/project/activity/projectToDos.mjs';
import { concerns11krqc6dzu1f1 as concerns } from '../../components/project/activity/concerns/concerns.mjs';
import { projectMessagessyigyk9vqeti as projectMessages } from '../../components/project/activity/messages.mjs';
import { scopeV318fctfa38mngh as scopeV3 } from '../../components/project/work/scope/scopev3.mjs';
import { projectTasks12j3aovmmzdca as projectTasks } from '../../components/project/work/punchList/projectTasks.mjs';
import { projectChangeOrders19dwzo9rdck4z as projectChangeOrders } from '../../components/project/work/changeOrders/projectChangeOrders.mjs';
import { draws35jr59nzlfey8 as draws } from '../../components/project/work/payApps/payAppsTab.mjs';
import { markAsRead30n3njkh9wkat as markAsRead } from '../../../extensions/HasReadBy.ext.mjs';
import { UnsafeProjectView23b4rskm6lqhw as UnsafeProjectView } from './DevProjectView.mjs';
import { delayolwo40i9ucjz as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { JumpTo_getInstance3ru9x2o8nieur as JumpTo_getInstance } from '../../../utils/JumpTo.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReady_instance37iasaqvolrrz as InternalReactiveNotReady_instance,
} from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import {
  set_value1vvx5pkb20ebv as set_value,
  withWritedlio9p0oewet as withWrite,
  interceptWrite2xi6g5kl52xuu as interceptWrite,
} from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../../sdk/errors.mjs';
import {
  UnlockProjectRequestsb9zq5gbmeux as UnlockProjectRequest,
  LineItem2rt64afaiyloc as LineItem,
  Incident3aojs8cp7629c as Incident,
  CompletionMessageComment2phagw82v6lch as CompletionMessageComment,
  ProjectLedgerItem1yul4cns1huli as ProjectLedgerItem,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { viewUnlockProposalDialog1s7xyjel5pmhj as viewUnlockProposalDialog } from '../../components/project/settlements/unlockProjectDialogs.mjs';
import { Companion_instance3euo5q27joywz as Companion_instance_0 } from '../../components/project/work/scope/LineItemCompletionForm.mjs';
import {
  navigateOrDialog1m0cnx3luzasq as navigateOrDialog,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
} from '../../components/nav/crowpay.mjs';
import { Companion_instance2o1tmep3w0ant as Companion_instance_1 } from '../../components/project/activity/concerns/IncidentReportForm.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  first58ocm7j58k3q as first,
  plus310ted5e4i90h as plus,
  toSet2orjxp16sotqu as toSet,
  asSequence2phdjljfh9jhx as asSequence,
  maxOrNull2e5ok5wkly1cp as maxOrNull,
  filterNotNull3qfgcwmxhwfxe as filterNotNull,
  firstOrNull1982767dljvdy as firstOrNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ViewSettlementDocs1y21duy3panzg as ViewSettlementDocs } from '../../components/project/settlements/ViewSettlementDocs.mjs';
import {
  onRemove3k528udkni1ni as onRemove,
  Key_instance6wd16m35aua5 as Key_instance,
} from '../../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  Reactive1jy75v4li6ldv as Reactive,
  ReactiveWithMutableValue1h1r6ig7acce5 as ReactiveWithMutableValue,
} from '../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  unreadIconWhen1430ixd91bo9h as unreadIconWhen,
  actionIcon360epyywhabwj as actionIcon,
  activityIcon1ob72qc2woiai as activityIcon,
} from '../../components/iconShortcuts.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_1 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  body3i5t0n7zprpqb as body,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
} from '../../theming/Titles.mjs';
import {
  coerceAtLeast1b3m6f7g22ivr as coerceAtLeast,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import {
  weightt34o7llf2uyq as weight,
  shownWhenxgf1ujy6rmvr as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { RadioToggleButton6jdt9lqh3p8p as RadioToggleButton } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioToggleButton.commonHtml.mjs';
import {
  specCenteredContent3evlhhbrk2e00 as specCenteredContent,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../../theming/buttons.mjs';
import { equalTo2dio0vrcsd3je as equalTo } from '../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_project24re8n4hoe63y as get_project,
  get_partyq13c2hdc8rqy as get_party,
  get_state3dimnrbngbj36 as get_state,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectLedgerItemFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { andvtrcuje7baox as and } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  KtMap140uvy3s5zad8 as KtMap,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isCancellable24xse61e0pt9z as isCancellable } from '../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import {
  to2cs3ny02qtbcb as to,
  Triple1vhi3d0dgpnjb as Triple,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  filter184huxd00uyfg as filter,
  mapsbvh18eqox7a as map,
  toSet2morh2kqexfa2 as toSet_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { requiresAction13nb01xm2r5gu as requiresAction } from '../../../extensions/FlowPermissions.ext.mjs';
import { hasConcernCard3nodxgigqanyg as hasConcernCard } from '../../components/project/activity/concerns/ConcernCardInfo.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { Companion_getInstance24j3x2uirrx0g as Companion_getInstance_2 } from '../../../sdk/ReadByModelCache.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { mutableRemember1h6fyyolumj0o as mutableRemember } from '../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import { ScrollingBehaviorImpl35p8dxbs74spr as ScrollingBehaviorImpl } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ScrollView.commonHtml.js.mjs';
import { ReactiveContextSuspending39biijty1bpc5 as ReactiveContextSuspending } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContextSuspending.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { header723gxwzzg7tp as header } from '../../components/project/header.mjs';
import { disputeBar3bttgvzigm2w3 as disputeBar } from '../../components/project/disputeBar.mjs';
import { projectLevelMessagesrgqtjljm2k9u as projectLevelMessages } from '../../components/project/projectLevelMessages.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { actionBar2229z9n90psciq as actionBar2 } from '../../components/project/actionBar.mjs';
import { previewInformation37nza2t378ikc as previewInformation } from '../../components/project/previewInformation.mjs';
import {
  OuterTabBar_getInstance2g83ti7eoew9h as OuterTabBar_getInstance,
  InnerTabBar_getInstance20l55y0u7bopn as InnerTabBar_getInstance,
} from '../../theming/tabs.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { notificationBar4efejtg2792g as notificationBar } from '../../theming/banners.mjs';
import {
  get_requiredMembershipRole1cjo4vwylx1kv as get_requiredMembershipRole,
  get_finishRegistrationMessage1yrf9ce4f09f0 as get_finishRegistrationMessage,
  get_awaitingApprovalMessage2f85iqlczrbum as get_awaitingApprovalMessage,
  renderFinishRegistrationc1cqjl7so0e8 as renderFinishRegistration,
  render2ibcvtmr1nr93 as render,
  MightBeContractorPage1c5hm6d3mwsqz as MightBeContractorPage,
} from '../contractor/IsContractorScreen.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.mja_1.f2();
}
function ProjectLens$Companion$_anonymous__9qr9so() {
  return createSimpleEnumSerializer('com.crowpay.views.screens.common.ProjectLens', values());
}
var ProjectLens_Contractor_instance;
var ProjectLens_Customer_instance;
var ProjectLens_Preview_instance;
function values() {
  return [ProjectLens_Contractor_getInstance(), ProjectLens_Customer_getInstance(), ProjectLens_Preview_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.mja_1 = lazy(tmp_0, ProjectLens$Companion$_anonymous__9qr9so);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_2;
function Companion_getInstance_3() {
  ProjectLens_initEntries();
  if (Companion_instance_2 === VOID)
    new (Companion())();
  return Companion_instance_2;
}
var ProjectLens_entriesInitialized;
function ProjectLens_initEntries() {
  if (ProjectLens_entriesInitialized)
    return Unit_instance;
  ProjectLens_entriesInitialized = true;
  ProjectLens_Contractor_instance = ProjectLens().nja('Contractor', 0);
  ProjectLens_Customer_instance = ProjectLens().nja('Customer', 1);
  ProjectLens_Preview_instance = ProjectLens().nja('Preview', 2);
  Companion_getInstance_3();
}
var $ENTRIES;
var ProjectLensClass;
function ProjectLens() {
  if (ProjectLensClass === VOID) {
    class $ extends Enum() {
      static nja(name, ordinal) {
        return this.c4(name, ordinal);
      }
      zgj() {
        return !this.equals(ProjectLens_Contractor_getInstance());
      }
    }
    initMetadataForClass($, 'ProjectLens', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_3});
    ProjectLensClass = $;
  }
  return ProjectLensClass;
}
var ActionImportance_Important_instance;
var ActionImportance_Critical_instance;
var ActionImportance_entriesInitialized;
function ActionImportance_initEntries() {
  if (ActionImportance_entriesInitialized)
    return Unit_instance;
  ActionImportance_entriesInitialized = true;
  ActionImportance_Important_instance = ActionImportance().oja('Important', 0, 'Important', color(ProjectState_InProgress_getInstance()), 0, resize(get_activity(Companion_getInstance()), get_rem(0.9)));
  ActionImportance_Critical_instance = ActionImportance().oja('Critical', 1, 'Critical', color(ProjectState_InProgress_getInstance()), 1, resize(get_activity(Companion_getInstance()), get_rem(0.9)));
}
var ActionImportanceClass;
function ActionImportance() {
  if (ActionImportanceClass === VOID) {
    class $ extends Enum() {
      static oja(name, ordinal, displayName, color, priority, icon) {
        var $this = this.c4(name, ordinal);
        $this.kg1_1 = displayName;
        $this.lg1_1 = color;
        $this.mg1_1 = priority;
        $this.ng1_1 = icon;
        return $this;
      }
      e90() {
        return this.kg1_1;
      }
      hg0() {
        return this.lg1_1;
      }
      g90() {
        return this.mg1_1;
      }
    }
    protoOf($).f90 = get_displayColor;
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'ActionImportance', VOID, VOID, [DirectlyDisplayableState(), Enum()]);
    ActionImportanceClass = $;
  }
  return ActionImportanceClass;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  println('Routing project, jumpto = ' + toString($this.pja_1.tez_1.f2()));
  var tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_rawSession();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0 == null) {
    // Inline function 'kotlin.apply' call
    var this_1 = new (LogInScreen())();
    // Inline function 'kotlin.also' call
    var this_2 = new (ProjectRouter())($this.pja_1.sez_1);
    this_2.tez_1.oam($this.pja_1.tez_1.f2());
    this_1.fir(this_2);
    tmp = this_1;
  } else {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = get_selectedContractor();
    var tmp_1 = await_1(this_3, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    if (!(tmp_1 == null)) {
      // Inline function 'kotlin.also' call
      var this_4 = new (ContractorProject())($this.pja_1.sez_1);
      this_4.sgj_1.oam($this.pja_1.tez_1.f2());
      tmp = this_4;
    } else {
      // Inline function 'kotlin.also' call
      var this_5 = new (ClientProject())($this.pja_1.sez_1);
      this_5.sgj_1.oam($this.pja_1.tez_1.f2());
      tmp = this_5;
    }
  }
  var routeTo = tmp;
  get_pageNavigator($this.qja_1).pd6(routeTo);
  return Unit_instance;
}
var ProjectRouter$render$slambdaClass;
function ProjectRouter$render$slambda() {
  if (ProjectRouter$render$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$frame) {
        this.pja_1 = this$0;
        this.qja_1 = $$this$frame;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectRouter$render$slambdaClass = $;
  }
  return ProjectRouter$render$slambdaClass;
}
function ProjectRouter$render$slambda_0(this$0, $$this$frame) {
  var i = new (ProjectRouter$render$slambda())(this$0, $$this$frame);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var ProjectRouterClass;
function ProjectRouter() {
  if (ProjectRouterClass === VOID) {
    class $ {
      constructor(id) {
        this.sez_1 = id;
        this.tez_1 = Signal().hak(null);
      }
      wd6(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        launch(view, VOID, VOID, ProjectRouter$render$slambda_0(this, view));
        var tmp = get_centered(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.activityIndicator' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (ActivityIndicator())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'ProjectRouter', VOID, VOID, [Page()]);
    ProjectRouterClass = $;
  }
  return ProjectRouterClass;
}
var UnauthorizedLensExceptionClass;
function UnauthorizedLensException() {
  if (UnauthorizedLensExceptionClass === VOID) {
    class $ extends Exception() {
      static uja(viewingAs) {
        var tmp;
        switch (viewingAs.b4_1) {
          case 0:
            tmp = 'a contractor';
            break;
          case 1:
            tmp = 'the client';
            break;
          case 2:
            tmp = 'anonymous';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        // Inline function 'kotlin.let' call
        var it = tmp;
        var tmp$ret$1 = 'You are attempting to view this page as ' + it + ', which is forbidden. You must be ' + it + ' of the project to view as ' + it + '.';
        var $this = this.ud(tmp$ret$1);
        captureStack($this, $this.tja_1);
        $this.sja_1 = viewingAs;
        return $this;
      }
    }
    initMetadataForClass($, 'UnauthorizedLensException');
    UnauthorizedLensExceptionClass = $;
  }
  return UnauthorizedLensExceptionClass;
}
function *_generator_assertViewerLens__wwyzzm(_this__u8e3s4, lens, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_rawSession();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = tmp0_safe_receiver.rfw_1;
    var tmp_1 = await_0(this_1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  }
  var self_0 = tmp_0;
  if (!(self_0 == null) && self_0.m88_1.d4(UserRole_Admin_getInstance()) >= 0)
    return Unit_instance;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = _this__u8e3s4.lfy();
  var tmp_2 = await_0(this_2, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var project = tmp_2;
  switch (lens.b4_1) {
    case 0:
      var tmp3_safe_receiver = self_0 == null ? null : self_0.k88_1;
      if (!project.x7a_1.equals(tmp3_safe_receiver == null ? null : tmp3_safe_receiver.g8c_1))
        throw UnauthorizedLensException().uja(lens);
      break;
    case 1:
      var tmp_3;
      if (!(project.z7a_1 == null)) {
        tmp_3 = !equals(project.z7a_1, self_0 == null ? null : self_0.d88_1);
      } else {
        tmp_3 = false;
      }

      if (tmp_3)
        throw UnauthorizedLensException().uja(lens);
      break;
    case 2:
      var tmp_4;
      var tmp6_safe_receiver = self_0 == null ? null : self_0.k88_1;
      if (!project.x7a_1.equals(tmp6_safe_receiver == null ? null : tmp6_safe_receiver.g8c_1)) {
        tmp_4 = !(project.z7a_1 == null);
      } else {
        tmp_4 = false;
      }

      if (tmp_4)
        throw UnauthorizedLensException().uja(lens);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return Unit_instance;
}
function assertViewerLens(_this__u8e3s4, lens, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_assertViewerLens__wwyzzm.bind(VOID, _this__u8e3s4, lens), $completion);
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.vja_1.f2();
}
function ProjectView$RegisterAccountSection$Companion$_anonymous__mtytny() {
  return createSimpleEnumSerializer('com.crowpay.views.screens.common.ProjectView.RegisterAccountSection', values_0());
}
var RegisterAccountSection_Register_instance;
var RegisterAccountSection_Operations_instance;
var RegisterAccountSection_Profile_instance;
var RegisterAccountSection_Verification_instance;
var RegisterAccountSection_Owners_instance;
var RegisterAccountSection_Bank_instance;
var RegisterAccountSection_Alerts_instance;
var RegisterAccountSection_Users_instance;
var RegisterAccountSection_Specs_instance;
function values_0() {
  return [RegisterAccountSection_Register_getInstance(), RegisterAccountSection_Operations_getInstance(), RegisterAccountSection_Profile_getInstance(), RegisterAccountSection_Verification_getInstance(), RegisterAccountSection_Owners_getInstance(), RegisterAccountSection_Bank_getInstance(), RegisterAccountSection_Alerts_getInstance(), RegisterAccountSection_Users_getInstance(), RegisterAccountSection_Specs_getInstance()];
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.vja_1 = lazy(tmp_0, ProjectView$RegisterAccountSection$Companion$_anonymous__mtytny);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_3;
function Companion_getInstance_4() {
  RegisterAccountSection_initEntries();
  if (Companion_instance_3 === VOID)
    new (Companion_0())();
  return Companion_instance_3;
}
var RegisterAccountSection_entriesInitialized;
function RegisterAccountSection_initEntries() {
  if (RegisterAccountSection_entriesInitialized)
    return Unit_instance;
  RegisterAccountSection_entriesInitialized = true;
  RegisterAccountSection_Register_instance = RegisterAccountSection().wja('Register', 0, 'Primary User');
  RegisterAccountSection_Operations_instance = RegisterAccountSection().wja('Operations', 1, 'Business Operations');
  RegisterAccountSection_Profile_instance = RegisterAccountSection().wja('Profile', 2, 'Business Profile');
  RegisterAccountSection_Verification_instance = RegisterAccountSection().wja('Verification', 3, 'Business Verification');
  RegisterAccountSection_Owners_instance = RegisterAccountSection().wja('Owners', 4, 'Owners');
  RegisterAccountSection_Bank_instance = RegisterAccountSection().wja('Bank', 5, 'Connect Bank');
  RegisterAccountSection_Alerts_instance = RegisterAccountSection().wja('Alerts', 6, 'Alerts');
  RegisterAccountSection_Users_instance = RegisterAccountSection().wja('Users', 7, 'Users');
  RegisterAccountSection_Specs_instance = RegisterAccountSection().wja('Specs', 8, 'Specifications');
  Companion_getInstance_4();
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.xja_1.f2();
}
function ProjectView$SectionGroup$Companion$_anonymous__z1zbyn() {
  return createSimpleEnumSerializer('com.crowpay.views.screens.common.ProjectView.SectionGroup', values_1());
}
var SectionGroup_Overview_instance;
var SectionGroup_Activity_instance;
var SectionGroup_Work_instance;
function values_1() {
  return [SectionGroup_Overview_getInstance(), SectionGroup_Activity_getInstance(), SectionGroup_Work_getInstance()];
}
function get_entries_0() {
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_1());
  return $ENTRIES_0;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_4 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.xja_1 = lazy(tmp_0, ProjectView$SectionGroup$Companion$_anonymous__z1zbyn);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_1(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_4;
function Companion_getInstance_5() {
  SectionGroup_initEntries();
  if (Companion_instance_4 === VOID)
    new (Companion_1())();
  return Companion_instance_4;
}
var SectionGroup_entriesInitialized;
function SectionGroup_initEntries() {
  if (SectionGroup_entriesInitialized)
    return Unit_instance;
  SectionGroup_entriesInitialized = true;
  SectionGroup_Overview_instance = SectionGroup().djb('Overview', 0, 'Overview', get_entries_1());
  SectionGroup_Activity_instance = SectionGroup().djb('Activity', 1, 'Activity', get_entries_2());
  SectionGroup_Work_instance = SectionGroup().djb('Work', 2, 'Work', get_entries_3());
  Companion_getInstance_5();
}
var $ENTRIES_0;
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      k2a() {
        var tmp = getKClass(ProjectSection());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = [getKClass(ActivitySection()), getKClass(InfoSection()), getKClass(WorkSection())];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_1 = [createSimpleEnumSerializer('com.crowpay.views.screens.common.ProjectView.ActivitySection', values_3()), createSimpleEnumSerializer('com.crowpay.views.screens.common.ProjectView.InfoSection', values_2()), createSimpleEnumSerializer('com.crowpay.views.screens.common.ProjectView.WorkSection', values_4())];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$8 = [];
        return SealedClassSerializer().j10('com.crowpay.views.screens.common.ProjectView.ProjectSection', tmp, tmp_0, tmp_1, tmp$ret$8);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_5;
function Companion_getInstance_6() {
  return Companion_instance_5;
}
function _get_$cachedSerializer__te6jhj_2($this) {
  return $this.ejb_1.f2();
}
function ProjectView$InfoSection$Companion$_anonymous__z43k2q() {
  return createSimpleEnumSerializer('com.crowpay.views.screens.common.ProjectView.InfoSection', values_2());
}
var InfoSection_Ledger_instance;
var InfoSection_Details_instance;
var InfoSection_Contacts_instance;
function values_2() {
  return [InfoSection_Ledger_getInstance(), InfoSection_Details_getInstance(), InfoSection_Contacts_getInstance()];
}
function get_entries_1() {
  if ($ENTRIES_1 == null)
    $ENTRIES_1 = enumEntries(values_2());
  return $ENTRIES_1;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_6 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.ejb_1 = lazy(tmp_0, ProjectView$InfoSection$Companion$_anonymous__z43k2q);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_2(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_6;
function Companion_getInstance_7() {
  InfoSection_initEntries();
  if (Companion_instance_6 === VOID)
    new (Companion_3())();
  return Companion_instance_6;
}
function ledger$ref() {
  var l = (p0, p1) => ledger(p0, p1);
  l.callableName = 'ledger';
  return l;
}
function projectDetails$ref() {
  var l = (p0, p1) => projectDetails(p0, p1);
  l.callableName = 'projectDetails';
  return l;
}
function contacts$ref() {
  var l = (p0, p1) => contacts(p0, p1);
  l.callableName = 'contacts';
  return l;
}
var InfoSection_entriesInitialized;
function InfoSection_initEntries() {
  if (InfoSection_entriesInitialized)
    return Unit_instance;
  InfoSection_entriesInitialized = true;
  InfoSection_Ledger_instance = InfoSection().ljb('Ledger', 0, 'Ledger', ledger$ref(), MemberRole_Manager_getInstance());
  InfoSection_Details_instance = InfoSection().ljb('Details', 1, 'Details', projectDetails$ref(), MemberRole_Employee_getInstance());
  InfoSection_Contacts_instance = InfoSection().ljb('Contacts', 2, 'Contacts', contacts$ref(), MemberRole_Employee_getInstance());
  Companion_getInstance_7();
}
var $ENTRIES_1;
function _get_$cachedSerializer__te6jhj_3($this) {
  return $this.mjb_1.f2();
}
function ProjectView$ActivitySection$Companion$_anonymous__8yylr5() {
  return createSimpleEnumSerializer('com.crowpay.views.screens.common.ProjectView.ActivitySection', values_3());
}
var ActivitySection_ToDos_instance;
var ActivitySection_Concerns_instance;
var ActivitySection_Messaging_instance;
function values_3() {
  return [ActivitySection_ToDos_getInstance(), ActivitySection_Concerns_getInstance(), ActivitySection_Messaging_getInstance()];
}
function get_entries_2() {
  if ($ENTRIES_2 == null)
    $ENTRIES_2 = enumEntries(values_3());
  return $ENTRIES_2;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      constructor() {
        Companion_instance_7 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.mjb_1 = lazy(tmp_0, ProjectView$ActivitySection$Companion$_anonymous__8yylr5);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_3(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_7;
function Companion_getInstance_8() {
  ActivitySection_initEntries();
  if (Companion_instance_7 === VOID)
    new (Companion_4())();
  return Companion_instance_7;
}
function projectToDos$ref() {
  var l = (p0, p1) => projectToDos(p0, p1);
  l.callableName = 'projectToDos';
  return l;
}
function concerns$ref() {
  var l = (p0, p1) => concerns(p0, p1);
  l.callableName = 'concerns';
  return l;
}
function projectMessages$ref() {
  var l = (p0, p1) => projectMessages(p0, p1);
  l.callableName = 'projectMessages';
  return l;
}
var ActivitySection_entriesInitialized;
function ActivitySection_initEntries() {
  if (ActivitySection_entriesInitialized)
    return Unit_instance;
  ActivitySection_entriesInitialized = true;
  ActivitySection_ToDos_instance = ActivitySection().tjb('ToDos', 0, "To-Do's", projectToDos$ref(), MemberRole_Manager_getInstance());
  ActivitySection_Concerns_instance = ActivitySection().tjb('Concerns', 1, 'Concerns', concerns$ref(), MemberRole_Manager_getInstance());
  ActivitySection_Messaging_instance = ActivitySection().tjb('Messaging', 2, 'Messaging', projectMessages$ref(), MemberRole_Manager_getInstance());
  Companion_getInstance_8();
}
var $ENTRIES_2;
function _get_$cachedSerializer__te6jhj_4($this) {
  return $this.ujb_1.f2();
}
function ProjectView$WorkSection$Companion$_anonymous__8o4bhd() {
  return createSimpleEnumSerializer('com.crowpay.views.screens.common.ProjectView.WorkSection', values_4());
}
var WorkSection_Scope_instance;
var WorkSection_Tasks_instance;
var WorkSection_ChangeOrders_instance;
var WorkSection_PayApps_instance;
function values_4() {
  return [WorkSection_Scope_getInstance(), WorkSection_Tasks_getInstance(), WorkSection_ChangeOrders_getInstance(), WorkSection_PayApps_getInstance()];
}
function get_entries_3() {
  if ($ENTRIES_3 == null)
    $ENTRIES_3 = enumEntries(values_4());
  return $ENTRIES_3;
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      constructor() {
        Companion_instance_8 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.ujb_1 = lazy(tmp_0, ProjectView$WorkSection$Companion$_anonymous__8o4bhd);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_4(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_8;
function Companion_getInstance_9() {
  WorkSection_initEntries();
  if (Companion_instance_8 === VOID)
    new (Companion_5())();
  return Companion_instance_8;
}
function scopeV3$ref() {
  var l = (p0, p1) => scopeV3(p0, p1);
  l.callableName = 'scopeV3';
  return l;
}
function ProjectView$WorkSection$lambda(_this__u8e3s4, it) {
  return projectTasks(it, _this__u8e3s4.lfy(), _this__u8e3s4.vgm(), _this__u8e3s4.wgm(), _this__u8e3s4.tgj());
}
function projectChangeOrders$ref() {
  var l = (p0, p1) => projectChangeOrders(p0, p1);
  l.callableName = 'projectChangeOrders';
  return l;
}
function draws$ref() {
  var l = (p0, p1) => draws(p0, p1);
  l.callableName = 'draws';
  return l;
}
var WorkSection_entriesInitialized;
function WorkSection_initEntries() {
  if (WorkSection_entriesInitialized)
    return Unit_instance;
  WorkSection_entriesInitialized = true;
  WorkSection_Scope_instance = WorkSection().bjc('Scope', 0, 'Scope', scopeV3$ref(), MemberRole_Employee_getInstance());
  WorkSection_Tasks_instance = WorkSection().bjc('Tasks', 1, 'Tasks', ProjectView$WorkSection$lambda, MemberRole_Employee_getInstance());
  WorkSection_ChangeOrders_instance = WorkSection().bjc('ChangeOrders', 2, 'Changes', projectChangeOrders$ref(), MemberRole_Manager_getInstance());
  WorkSection_PayApps_instance = WorkSection().bjc('PayApps', 3, 'Draws', draws$ref(), MemberRole_Manager_getInstance());
  Companion_getInstance_9();
}
var $ENTRIES_3;
function *_generator_invoke__zhh2q8_0($this, $this$rememberSuspending, $completion) {
  var tmp = rerunOn($this.cjc_1.xgi_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_rawSession();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var session = tmp_0;
  var tmp_1;
  if (!(session == null)) {
    var tmp_2 = session.vfw().dfh_1.mfs($completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    tmp_1 = tmp_2.i1();
  } else {
    tmp_1 = false;
  }
  return tmp_1;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.rfv_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.djc_1.lfy();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = markAsRead(tmp_0, tmp$ret$1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $this$launch, $completion) {
  var tmp = $this.ejc_1;
  if (!(tmp instanceof UnsafeProjectView())) {
    var tmp_0 = assertViewerLens($this.ejc_1, $this.ejc_1.tgj(), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.fjc_1.sgj_1;
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp_0 = delay(500n, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1 = JumpTo_getInstance();
    var tmp0 = tmp0_safe_receiver.n8v_1.b4_1;
    tmp_1.dg5(tmp0_safe_receiver, VOID, tmp0 === 2 ? Align_End_getInstance() : tmp0 === 7 ? Align_Start_getInstance() : tmp0 === 3 ? Align_Center_getInstance() : tmp0 === 13 ? Align_Center_getInstance() : Align_Start_getInstance());
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $this$withWrite, group, $completion) {
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  var this_0 = $this.gjc_1.qgj_1.sah();
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
  var tmp;
  if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
    tmp = null;
  } else {
    if (tmp0_subject instanceof InternalReactiveThrownException()) {
      _ReactiveState___get_raw__impl__92ipya(this_0).uah_1;
      tmp = null;
    } else {
      if (tmp0_subject instanceof InternalReactiveWrapper()) {
        var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0).tah_1;
        var it = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_1 = $this.gjc_1.ogj_1;
        var tmp_1 = await_0(this_1, $completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        var tmp$ret$2 = tmp_1;
        tmp = $this.gjc_1.mj3(tmp$ret$2, it);
      } else {
        var it_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_2 = $this.gjc_1.ogj_1;
        var tmp_2 = await_0(this_2, $completion);
        if (tmp_2 === get_COROUTINE_SUSPENDED())
          tmp_2 = yield tmp_2;
        var tmp$ret$5 = tmp_2;
        tmp = $this.gjc_1.mj3(tmp$ret$5, it_0);
      }
    }
  }
  var prevUnread = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.gjc_1.rgj_1;
  var tmp_3 = await_0(this_3, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp$ret$10 = tmp_3;
  set_value($this.gjc_1.qgj_1, group.hjc(tmp$ret$10));
  var tmp1_safe_receiver = prevUnread == null ? null : prevUnread.cfv_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.zbe(get_AppScope());
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ijc_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp;
}
function *_generator_invoke__zhh2q8_6($this, $this$interceptWrite, section, $completion) {
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  var this_0 = $this.jjc_1.qgj_1.sah();
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
  var tmp;
  if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
    tmp = null;
  } else {
    if (tmp0_subject instanceof InternalReactiveThrownException()) {
      _ReactiveState___get_raw__impl__92ipya(this_0).uah_1;
      tmp = null;
    } else {
      if (tmp0_subject instanceof InternalReactiveWrapper()) {
        var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0).tah_1;
        var it = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_1 = $this.jjc_1.ogj_1;
        var tmp_1 = await_0(this_1, $completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        var tmp$ret$2 = tmp_1;
        tmp = $this.jjc_1.mj3(tmp$ret$2, it);
      } else {
        var it_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_2 = $this.jjc_1.ogj_1;
        var tmp_2 = await_0(this_2, $completion);
        if (tmp_2 === get_COROUTINE_SUSPENDED())
          tmp_2 = yield tmp_2;
        var tmp$ret$5 = tmp_2;
        tmp = $this.jjc_1.mj3(tmp$ret$5, it_0);
      }
    }
  }
  var prevTabUnread = tmp;
  set_value($this$interceptWrite, section);
  if (prevTabUnread == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver = prevTabUnread.cfv_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.zbe(get_AppScope());
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_7($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.kjc_1.lj3();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.find' call
  var tmp0 = tmp;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.j86_1.equals($this.ljc_1)) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    throw NotFound().pfx(getKClass(UnlockProjectRequest()), null);
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var request = tmp_0;
  viewUnlockProposalDialog($this.kjc_1, $this.mjc_1, request, request.n86_1 === $this.kjc_1.tgj().zgj(), $this.kjc_1.tgj());
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_8($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.njc_1.vgm();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.find' call
  var tmp0 = tmp;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.mf9_1.equals($this.ojc_1)) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    throw NotFound().pfx(getKClass(LineItem()), null);
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var item = tmp_0;
  var tmp_1 = Companion_instance_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.njc_1.lfy();
  var tmp_2 = await_0(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp$ret$4 = tmp_2;
  var tmp_3 = tmp_1.egu(item, tmp$ret$4, $this.njc_1.tgj(), VOID, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  // Inline function 'kotlin.let' call
  var this_2 = tmp_3;
  var this_3 = $this.pjc_1;
  navigateOrDialog(this_3, this_2);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_9($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.qjc_1.igt();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.find' call
  var tmp0 = tmp;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.b63_1.equals($this.rjc_1)) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    throw NotFound().pfx(getKClass(Incident()), null);
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var incident = tmp_0;
  var tmp_1 = Companion_instance_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.qjc_1.lfy();
  var tmp_2 = await_0(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = tmp_2;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.qjc_1.egt();
  var tmp_4 = await_0(this_2, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  // Inline function 'kotlin.collections.filter' call
  var tmp0_0 = tmp_4;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s_0 = tmp0_0.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    if (element_0.v67_1.equals($this.rjc_1)) {
      destination.v(element_0);
    }
  }
  var tmp_5 = tmp_1.xgq(tmp_3, incident, destination, $this.qjc_1.tgj(), $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  // Inline function 'kotlin.let' call
  var this_3 = tmp_5;
  var this_4 = $this.sjc_1;
  navigateOrDialog(this_4, this_3);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_10($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.tjc_1.ggt();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.find' call
  var tmp0 = tmp;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.n5d_1.equals($this.ujc_1)) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    throw NotFound().pfx(getKClass(CompletionMessageComment()), null);
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var comment = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.tjc_1.vgm();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  // Inline function 'kotlin.collections.find' call
  var tmp0_0 = tmp_1;
  var tmp$ret$6;
  $l$block_0: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s_0 = tmp0_0.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element_0 = _iterator__ex2g4s_0.o1();
      if (element_0.mf9_1.equals(comment.q5d_1)) {
        tmp$ret$6 = element_0;
        break $l$block_0;
      }
    }
    tmp$ret$6 = null;
  }
  var tmp1_elvis_lhs = tmp$ret$6;
  var tmp_2;
  if (tmp1_elvis_lhs == null) {
    throw NotFound().pfx(getKClass(LineItem()), null);
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  var item = tmp_2;
  var tmp_3 = Companion_instance_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.tjc_1.lfy();
  var tmp_4 = await_0(this_2, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp$ret$8 = tmp_4;
  var tmp_5 = tmp_3.egu(item, tmp$ret$8, $this.tjc_1.tgj(), VOID, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  // Inline function 'kotlin.let' call
  var this_3 = tmp_5;
  var this_4 = $this.vjc_1;
  navigateOrDialog(this_4, this_3);
  return Unit_instance;
}
var RegisterAccountSectionClass;
function RegisterAccountSection() {
  if (RegisterAccountSectionClass === VOID) {
    class $ extends Enum() {
      static wja(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.tiz_1 = displayName;
        return $this;
      }
    }
    initMetadataForClass($, 'RegisterAccountSection', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_4});
    RegisterAccountSectionClass = $;
  }
  return RegisterAccountSectionClass;
}
function requiresReview($this, _this__u8e3s4) {
  return $this.tgj().equals(ProjectLens_Contractor_getInstance()) ? _this__u8e3s4.mfy().equals(LineItemState_NotApproved_getInstance()) : _this__u8e3s4.mfy().equals(LineItemState_RequestingReview_getInstance());
}
var SectionGroupClass;
function SectionGroup() {
  if (SectionGroupClass === VOID) {
    class $ extends Enum() {
      static djb(name, ordinal, displayName, sections) {
        var $this = this.c4(name, ordinal);
        $this.ajb_1 = displayName;
        $this.bjb_1 = sections;
        $this.cjb_1 = null;
        return $this;
      }
      e90() {
        return this.ajb_1;
      }
      hjc(role) {
        var tmp0_elvis_lhs = this.cjb_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var tmp_0;
          if (role == null) {
            tmp_0 = first(this.bjb_1);
          } else {
            var tmp0 = this.bjb_1;
            var tmp$ret$1;
            $l$block: {
              // Inline function 'kotlin.collections.first' call
              var _iterator__ex2g4s = tmp0.m1();
              while (_iterator__ex2g4s.n1()) {
                var element = _iterator__ex2g4s.o1();
                if (element.wjc().d4(role) <= 0) {
                  tmp$ret$1 = element;
                  break $l$block;
                }
              }
              throw NoSuchElementException().o('Collection contains no element matching the predicate.');
            }
            tmp_0 = tmp$ret$1;
          }
          tmp = tmp_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
    }
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'SectionGroup', VOID, VOID, [HasDisplayName(), Enum()], VOID, VOID, {0: Companion_getInstance_5});
    SectionGroupClass = $;
  }
  return SectionGroupClass;
}
var ProjectSectionClass;
function ProjectSection() {
  if (ProjectSectionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ProjectSection', VOID, VOID, [HasDisplayName()], VOID, VOID, {0: Companion_getInstance_6});
    ProjectSectionClass = $;
  }
  return ProjectSectionClass;
}
var InfoSectionClass;
function InfoSection() {
  if (InfoSectionClass === VOID) {
    class $ extends Enum() {
      static ljb(name, ordinal, displayName, render, roleRequirement, stateRequirement) {
        stateRequirement = stateRequirement === VOID ? ProjectState_Invited_getInstance() : stateRequirement;
        var $this = this.c4(name, ordinal);
        $this.hjb_1 = displayName;
        $this.ijb_1 = render;
        $this.jjb_1 = roleRequirement;
        $this.kjb_1 = stateRequirement;
        return $this;
      }
      e90() {
        return this.hjb_1;
      }
      vds() {
        return this.ijb_1;
      }
      wjc() {
        return this.jjb_1;
      }
      yjc() {
        return this.kjb_1;
      }
      xjc() {
        return SectionGroup_Overview_getInstance();
      }
    }
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'InfoSection', VOID, VOID, [ProjectSection(), Enum()], VOID, VOID, {0: Companion_getInstance_7});
    InfoSectionClass = $;
  }
  return InfoSectionClass;
}
var ActivitySectionClass;
function ActivitySection() {
  if (ActivitySectionClass === VOID) {
    class $ extends Enum() {
      static tjb(name, ordinal, displayName, render, roleRequirement, stateRequirement) {
        stateRequirement = stateRequirement === VOID ? ProjectState_Invited_getInstance() : stateRequirement;
        var $this = this.c4(name, ordinal);
        $this.pjb_1 = displayName;
        $this.qjb_1 = render;
        $this.rjb_1 = roleRequirement;
        $this.sjb_1 = stateRequirement;
        return $this;
      }
      e90() {
        return this.pjb_1;
      }
      vds() {
        return this.qjb_1;
      }
      wjc() {
        return this.rjb_1;
      }
      yjc() {
        return this.sjb_1;
      }
      xjc() {
        return SectionGroup_Activity_getInstance();
      }
    }
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'ActivitySection', VOID, VOID, [ProjectSection(), Enum()], VOID, VOID, {0: Companion_getInstance_8});
    ActivitySectionClass = $;
  }
  return ActivitySectionClass;
}
var WorkSectionClass;
function WorkSection() {
  if (WorkSectionClass === VOID) {
    class $ extends Enum() {
      static bjc(name, ordinal, displayName, render, roleRequirement, stateRequirement) {
        stateRequirement = stateRequirement === VOID ? ProjectState_Invited_getInstance() : stateRequirement;
        var $this = this.c4(name, ordinal);
        $this.xjb_1 = displayName;
        $this.yjb_1 = render;
        $this.zjb_1 = roleRequirement;
        $this.ajc_1 = stateRequirement;
        return $this;
      }
      e90() {
        return this.xjb_1;
      }
      vds() {
        return this.yjb_1;
      }
      wjc() {
        return this.zjb_1;
      }
      yjc() {
        return this.ajc_1;
      }
      xjc() {
        return SectionGroup_Work_getInstance();
      }
    }
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'WorkSection', VOID, VOID, [ProjectSection(), Enum()], VOID, VOID, {0: Companion_getInstance_9});
    WorkSectionClass = $;
  }
  return WorkSectionClass;
}
function registerJumpTos($this, _this__u8e3s4) {
  registerJumpTos$routesTo(JumpTo_getInstance().tg3_1, _this__u8e3s4, $this, WorkSection_Scope_getInstance());
  registerJumpTos$routesTo(JumpTo_getInstance().og3_1, _this__u8e3s4, $this, WorkSection_ChangeOrders_getInstance());
  registerJumpTos$routesTo(JumpTo_getInstance().pg3_1, _this__u8e3s4, $this, WorkSection_ChangeOrders_getInstance());
  registerJumpTos$routesTo(JumpTo_getInstance().vg3_1, _this__u8e3s4, $this, WorkSection_PayApps_getInstance());
  registerJumpTos$routesTo(JumpTo_getInstance().ug3_1, _this__u8e3s4, $this, WorkSection_Scope_getInstance());
  registerJumpTos$routesTo(JumpTo_getInstance().yg3_1, _this__u8e3s4, $this, WorkSection_Tasks_getInstance());
  registerJumpTos$routesTo(JumpTo_getInstance().xg3_1, _this__u8e3s4, $this, WorkSection_Tasks_getInstance());
  registerJumpTos$routesTo(JumpTo_getInstance().kg3_1, _this__u8e3s4, $this, InfoSection_Details_getInstance());
  registerJumpTos$routesTo(JumpTo_getInstance().ng3_1, _this__u8e3s4, $this, InfoSection_Ledger_getInstance());
  registerJumpTos$routesTo(JumpTo_getInstance().lg3_1, _this__u8e3s4, $this, ActivitySection_ToDos_getInstance());
  registerJumpTos$routesTo(JumpTo_getInstance().mg3_1, _this__u8e3s4, $this, ActivitySection_Messaging_getInstance());
  var tmp = JumpTo_getInstance().ag4_1;
  // Inline function 'kotlin.also' call
  var this_0 = tmp.vah(() => {
    navigateOrDialog(_this__u8e3s4, new (ViewSettlementDocs())($this.lf8(), $this.tgj(), $this));
    return Unit_instance;
  });
  onRemove(_this__u8e3s4, this_0);
  var tmp_0 = JumpTo_getInstance().bg4_1;
  // Inline function 'kotlin.also' call
  var this_1 = tmp_0.xg4((id) => {
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, ProjectView$registerJumpTos$lambda$slambda_0($this, id, _this__u8e3s4));
    return Unit_instance;
  });
  onRemove(_this__u8e3s4, this_1);
  var tmp_1 = JumpTo_getInstance().qg3_1;
  // Inline function 'kotlin.also' call
  var this_2 = tmp_1.xg4((id) => {
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, ProjectView$registerJumpTos$lambda$slambda_2($this, id, _this__u8e3s4));
    return Unit_instance;
  });
  onRemove(_this__u8e3s4, this_2);
  var tmp_2 = JumpTo_getInstance().sg3_1;
  // Inline function 'kotlin.also' call
  var this_3 = tmp_2.xg4((id) => {
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, ProjectView$registerJumpTos$lambda$slambda_4($this, id, _this__u8e3s4));
    return Unit_instance;
  });
  onRemove(_this__u8e3s4, this_3);
  var tmp_3 = JumpTo_getInstance().rg3_1;
  // Inline function 'kotlin.also' call
  var this_4 = tmp_3.xg4((id) => {
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, ProjectView$registerJumpTos$lambda$slambda_6($this, id, _this__u8e3s4));
    return Unit_instance;
  });
  onRemove(_this__u8e3s4, this_4);
}
var ButtonsClass;
function Buttons() {
  if (ButtonsClass === VOID) {
    class $ {}
    initMetadataForObject($, 'Buttons');
    ButtonsClass = $;
  }
  return ButtonsClass;
}
var Buttons_instance;
function Buttons_getInstance() {
  return Buttons_instance;
}
function registerJumpTos$routesTo(_this__u8e3s4, $this_registerJumpTos, this$0, section) {
  // Inline function 'kotlin.also' call
  var this_0 = _this__u8e3s4.vah(() => {
    set_value(this$0.qgj_1, section);
    return Unit_instance;
  });
  onRemove($this_registerJumpTos, this_0);
  return this_0;
}
var ProjectView$needsPaymentMethods$slambdaClass;
function ProjectView$needsPaymentMethods$slambda() {
  if (ProjectView$needsPaymentMethods$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.cjc_1 = this$0;
      }
      yah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectView$needsPaymentMethods$slambdaClass = $;
  }
  return ProjectView$needsPaymentMethods$slambdaClass;
}
function ProjectView$needsPaymentMethods$slambda_0(this$0) {
  var i = new (ProjectView$needsPaymentMethods$slambda())(this$0);
  var l = ($this$rememberSuspending, $completion) => i.yah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function ProjectView$pendingDraws$lambda$lambda(it) {
  return it.z6v_1;
}
function ProjectView$pendingDraws$lambda$lambda_0(it) {
  return it.p6v_1;
}
function ProjectView$selectedSection$lambda($this$interceptImmediateWrite, it) {
  it.xjc().cjb_1 = it;
  set_value($this$interceptImmediateWrite, it);
  return Unit_instance;
}
function ProjectView$myMemberRole$lambda($this$remember) {
  var tmp0_safe_receiver = $this$remember.daj(get_rawSession());
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$remember.daj(tmp0_safe_receiver.rfw_1);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.k88_1;
  return tmp2_safe_receiver == null ? null : tmp2_safe_receiver.h8c_1;
}
var ProjectView$projectView$slambdaClass;
function ProjectView$projectView$slambda() {
  if (ProjectView$projectView$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.djc_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectView$projectView$slambdaClass = $;
  }
  return ProjectView$projectView$slambdaClass;
}
function ProjectView$projectView$slambda_0(this$0) {
  var i = new (ProjectView$projectView$slambda())(this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var ProjectView$projectView$slambdaClass_0;
function ProjectView$projectView$slambda_1() {
  if (ProjectView$projectView$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.ejc_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectView$projectView$slambdaClass_0 = $;
  }
  return ProjectView$projectView$slambdaClass_0;
}
function ProjectView$projectView$slambda_2(this$0) {
  var i = new (ProjectView$projectView$slambda_1())(this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var ProjectView$projectView$slambdaClass_1;
function ProjectView$projectView$slambda_3() {
  if (ProjectView$projectView$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.fjc_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectView$projectView$slambdaClass_1 = $;
  }
  return ProjectView$projectView$slambdaClass_1;
}
function ProjectView$projectView$slambda_4(this$0) {
  var i = new (ProjectView$projectView$slambda_3())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var ProjectView$projectView$slambdaClass_2;
function ProjectView$projectView$slambda_5() {
  if (ProjectView$projectView$slambdaClass_2 === VOID) {
    class $ {
      uao($completion) {
        JumpTo_getInstance().lg3_1.rg4();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectView$projectView$slambdaClass_2 = $;
  }
  return ProjectView$projectView$slambdaClass_2;
}
function ProjectView$projectView$slambda_6() {
  var i = new (ProjectView$projectView$slambda_5())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ProjectView$projectView$slambdaClass_3;
function ProjectView$projectView$slambda_7() {
  if (ProjectView$projectView$slambdaClass_3 === VOID) {
    class $ {
      constructor(this$0) {
        this.gjc_1 = this$0;
      }
      zjc($this$withWrite, group, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, $this$withWrite, group), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.zjc(tmp, p2 instanceof SectionGroup() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ProjectView$projectView$slambdaClass_3 = $;
  }
  return ProjectView$projectView$slambdaClass_3;
}
function ProjectView$projectView$slambda_8(this$0) {
  var i = new (ProjectView$projectView$slambda_7())(this$0);
  var l = ($this$withWrite, group, $completion) => i.zjc($this$withWrite, group, $completion);
  l.$arity = 2;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var ProjectView$projectView$lambda$slambdaClass;
function ProjectView$projectView$lambda$slambda() {
  if (ProjectView$projectView$lambda$slambdaClass === VOID) {
    class $ {
      constructor($group) {
        this.ijc_1 = $group;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectView$projectView$lambda$slambdaClass = $;
  }
  return ProjectView$projectView$lambda$slambdaClass;
}
function ProjectView$projectView$lambda$slambda_0($group) {
  var i = new (ProjectView$projectView$lambda$slambda())($group);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function RowOrCol$_get_shown_$ref_m8lfse(p0) {
  return () => p0.yb8();
}
function RowOrCol$_set_shown_$ref_7290m6(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var ProjectView$projectView$slambdaClass_4;
function ProjectView$projectView$slambda_9() {
  if (ProjectView$projectView$slambdaClass_4 === VOID) {
    class $ {
      constructor(this$0) {
        this.jjc_1 = this$0;
      }
      ajd($this$interceptWrite, section, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, $this$interceptWrite, section), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, ReactiveWithMutableValue()) : false) ? p1 : THROW_CCE();
        return this.ajd(tmp, (!(p2 == null) ? isInterface(p2, ProjectSection()) : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ProjectView$projectView$slambdaClass_4 = $;
  }
  return ProjectView$projectView$slambdaClass_4;
}
function ProjectView$projectView$slambda_10(this$0) {
  var i = new (ProjectView$projectView$slambda_9())(this$0);
  var l = ($this$interceptWrite, section, $completion) => i.ajd($this$interceptWrite, section, $completion);
  l.$arity = 2;
  return l;
}
function ProjectView$projectView$lambda$lambda$lambda($section, this$0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
    var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    _this__u8e3s4.gbb(p, view);
    view.zbm(false);
    view.bb9(get_AppDimensions().og2_1);
    get_centered(view);
    unreadIconWhen(view, ($this$unreadIconWhen) => {
      var tmp0_safe_receiver = this$0.mj3($this$unreadIconWhen.daj(this$0.ogj_1), $section);
      return (tmp0_safe_receiver == null ? null : $this$unreadIconWhen.daj(tmp0_safe_receiver)) === true;
    });
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
    Companion_getInstance_1();
    var tmp = get_centered(view);
    view.lbb(tmp, actionIcon(view, VOID, ($this$actionIcon) => this$0.mj3($this$actionIcon.daj(this$0.pgj_1), $section)));
    view.lbb(get_centered(view), body(view, $section.e90()));
    _this__u8e3s4.hbb(p, view);
    return view;
  };
}
function ProjectView$projectView$lambda$lambda$lambda_0($content) {
  return ($this$specCenteredContent) => $content($this$specCenteredContent);
}
function ProjectView$projectView$lambda$lambda($next, $sectionWithAction, this$0) {
  return ($this$swap) => {
    var groupSections = $next;
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$swap.pc());
    var tmp0_elvis_lhs = $this$swap.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$swap : tmp0_elvis_lhs;
    $this$swap.gbb(p, view);
    view.zbm(false);
    var _iterator__ex2g4s = groupSections.m1();
    while (_iterator__ex2g4s.n1()) {
      var section = _iterator__ex2g4s.o1();
      if (get_viewIsNarrow(view)) {
        if (groupSections.p1() > 3)
          weight(view, 1.0 + coerceAtLeast((section.e90().length - 6 | 0) / 8.0, 0.0));
        else
          get_expanding(view);
      }
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      var tmp = view.jbb(ButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.radioToggleButton' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (RadioToggleButton())(view.pc());
      var tmp0_elvis_lhs_0 = view.ebb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.gbb(p_0, view_0);
      var content = ProjectView$projectView$lambda$lambda$lambda(section, this$0);
      if (get_viewIsNarrow(view_0))
        view_0.lbb(get_centered(view_0), content(view_0));
      else {
        specCenteredContent(view_0, VOID, ProjectView$projectView$lambda$lambda$lambda_0(content));
      }
      view_0.zah(view_0.bc9_1, equalTo($sectionWithAction, section));
      view.hbb(p_0, view_0);
      view.lbb(tmp, view_0);
    }
    $this$swap.hbb(p, view);
    return view;
  };
}
var ProjectView$registerJumpTos$lambda$slambdaClass;
function ProjectView$registerJumpTos$lambda$slambda() {
  if (ProjectView$registerJumpTos$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $id, $this_registerJumpTos) {
        this.kjc_1 = this$0;
        this.ljc_1 = $id;
        this.mjc_1 = $this_registerJumpTos;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectView$registerJumpTos$lambda$slambdaClass = $;
  }
  return ProjectView$registerJumpTos$lambda$slambdaClass;
}
function ProjectView$registerJumpTos$lambda$slambda_0(this$0, $id, $this_registerJumpTos) {
  var i = new (ProjectView$registerJumpTos$lambda$slambda())(this$0, $id, $this_registerJumpTos);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var ProjectView$registerJumpTos$lambda$slambdaClass_0;
function ProjectView$registerJumpTos$lambda$slambda_1() {
  if (ProjectView$registerJumpTos$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $id, $this_registerJumpTos) {
        this.njc_1 = this$0;
        this.ojc_1 = $id;
        this.pjc_1 = $this_registerJumpTos;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectView$registerJumpTos$lambda$slambdaClass_0 = $;
  }
  return ProjectView$registerJumpTos$lambda$slambdaClass_0;
}
function ProjectView$registerJumpTos$lambda$slambda_2(this$0, $id, $this_registerJumpTos) {
  var i = new (ProjectView$registerJumpTos$lambda$slambda_1())(this$0, $id, $this_registerJumpTos);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var ProjectView$registerJumpTos$lambda$slambdaClass_1;
function ProjectView$registerJumpTos$lambda$slambda_3() {
  if (ProjectView$registerJumpTos$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0, $id, $this_registerJumpTos) {
        this.qjc_1 = this$0;
        this.rjc_1 = $id;
        this.sjc_1 = $this_registerJumpTos;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectView$registerJumpTos$lambda$slambdaClass_1 = $;
  }
  return ProjectView$registerJumpTos$lambda$slambdaClass_1;
}
function ProjectView$registerJumpTos$lambda$slambda_4(this$0, $id, $this_registerJumpTos) {
  var i = new (ProjectView$registerJumpTos$lambda$slambda_3())(this$0, $id, $this_registerJumpTos);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var ProjectView$registerJumpTos$lambda$slambdaClass_2;
function ProjectView$registerJumpTos$lambda$slambda_5() {
  if (ProjectView$registerJumpTos$lambda$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0, $id, $this_registerJumpTos) {
        this.tjc_1 = this$0;
        this.ujc_1 = $id;
        this.vjc_1 = $this_registerJumpTos;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectView$registerJumpTos$lambda$slambdaClass_2 = $;
  }
  return ProjectView$registerJumpTos$lambda$slambdaClass_2;
}
function ProjectView$registerJumpTos$lambda$slambda_6(this$0, $id, $this_registerJumpTos) {
  var i = new (ProjectView$registerJumpTos$lambda$slambda_5())(this$0, $id, $this_registerJumpTos);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function RegisterAccountSection_Register_getInstance() {
  RegisterAccountSection_initEntries();
  return RegisterAccountSection_Register_instance;
}
function RegisterAccountSection_Operations_getInstance() {
  RegisterAccountSection_initEntries();
  return RegisterAccountSection_Operations_instance;
}
function RegisterAccountSection_Profile_getInstance() {
  RegisterAccountSection_initEntries();
  return RegisterAccountSection_Profile_instance;
}
function RegisterAccountSection_Verification_getInstance() {
  RegisterAccountSection_initEntries();
  return RegisterAccountSection_Verification_instance;
}
function RegisterAccountSection_Owners_getInstance() {
  RegisterAccountSection_initEntries();
  return RegisterAccountSection_Owners_instance;
}
function RegisterAccountSection_Bank_getInstance() {
  RegisterAccountSection_initEntries();
  return RegisterAccountSection_Bank_instance;
}
function RegisterAccountSection_Alerts_getInstance() {
  RegisterAccountSection_initEntries();
  return RegisterAccountSection_Alerts_instance;
}
function RegisterAccountSection_Users_getInstance() {
  RegisterAccountSection_initEntries();
  return RegisterAccountSection_Users_instance;
}
function RegisterAccountSection_Specs_getInstance() {
  RegisterAccountSection_initEntries();
  return RegisterAccountSection_Specs_instance;
}
function SectionGroup_Overview_getInstance() {
  SectionGroup_initEntries();
  return SectionGroup_Overview_instance;
}
function SectionGroup_Activity_getInstance() {
  SectionGroup_initEntries();
  return SectionGroup_Activity_instance;
}
function SectionGroup_Work_getInstance() {
  SectionGroup_initEntries();
  return SectionGroup_Work_instance;
}
function InfoSection_Ledger_getInstance() {
  InfoSection_initEntries();
  return InfoSection_Ledger_instance;
}
function InfoSection_Details_getInstance() {
  InfoSection_initEntries();
  return InfoSection_Details_instance;
}
function InfoSection_Contacts_getInstance() {
  InfoSection_initEntries();
  return InfoSection_Contacts_instance;
}
function ActivitySection_ToDos_getInstance() {
  ActivitySection_initEntries();
  return ActivitySection_ToDos_instance;
}
function ActivitySection_Concerns_getInstance() {
  ActivitySection_initEntries();
  return ActivitySection_Concerns_instance;
}
function ActivitySection_Messaging_getInstance() {
  ActivitySection_initEntries();
  return ActivitySection_Messaging_instance;
}
function WorkSection_Scope_getInstance() {
  WorkSection_initEntries();
  return WorkSection_Scope_instance;
}
function WorkSection_Tasks_getInstance() {
  WorkSection_initEntries();
  return WorkSection_Tasks_instance;
}
function WorkSection_ChangeOrders_getInstance() {
  WorkSection_initEntries();
  return WorkSection_ChangeOrders_instance;
}
function WorkSection_PayApps_getInstance() {
  WorkSection_initEntries();
  return WorkSection_PayApps_instance;
}
var ProjectViewClass;
function ProjectView() {
  if (ProjectViewClass === VOID) {
    class $ {
      constructor(lens_0, $box) {
        boxApply(this, $box);
        this.dgi_1 = lens_0;
        this.egi_1 = HashMap().n8();
        var tmp = this;
        tmp.fgi_1 = remember(VOID, VOID, VOID, ($this$remember) => truncate($this$remember.daj(this.lfy()).b7b_1, 15));
        var tmp_0 = this;
        tmp_0.ggi_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var p = $this$remember.daj(this.lfy());
          return this.tgj().equals(ProjectLens_Preview_getInstance()) && (p.u7b_1.equals(ProjectState_WaitingApproval_getInstance()) || p.u7b_1.equals(ProjectState_Invited_getInstance())) && $this$remember.daj(get_rawSession()) == null;
        });
        var tmp_1 = this;
        tmp_1.hgi_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.lfy()).t97());
        var tmp_2 = this;
        tmp_2.igi_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.lfy()).u7b_1.equals(ProjectState_Accepted_getInstance()) && $this$remember.daj(this.vgj()).i1());
        var tmp_3 = this;
        tmp_3.jgi_1 = remember(VOID, VOID, VOID, ($this$remember) => MonetaryValue__compareTo_impl_w7ul1r($this$remember.daj(this.lfy()).r97(), Companion_instance.r91(0n)) > 0);
        var tmp_4 = this;
        tmp_4.kgi_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.lfy()).u7b_1.equals(ProjectState_SubstantialCompletion_getInstance()));
        var tmp_5 = this;
        tmp_5.lgi_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.lfy()).u7b_1.equals(ProjectState_RequestingComplete_getInstance()));
        var tmp_6 = this;
        tmp_6.mgi_1 = remember(VOID, VOID, VOID, ($this$remember) => this.tgj().equals(ProjectLens_Contractor_getInstance()) && $this$remember.daj(this.kgi_1));
        var tmp_7 = this;
        tmp_7.ngi_1 = remember(VOID, VOID, VOID, ($this$remember) => this.tgj().equals(ProjectLens_Customer_getInstance()) && $this$remember.daj(this.lgi_1));
        var tmp_8 = this;
        tmp_8.ogi_1 = remember(VOID, VOID, VOID, ($this$remember) => this.tgj().equals(ProjectLens_Customer_getInstance()) && !$this$remember.daj(this.hgi_1));
        var tmp_9 = this;
        tmp_9.pgi_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var project = $this$remember.daj(this.lfy());
          var remainingEscrowDeposits = MonetaryValue__minus_impl_jw9qyp(project.w7b_1, project.a7c_1);
          return this.tgj().equals(ProjectLens_Contractor_getInstance()) && project.u7b_1.d4(ProjectState_Accepted_getInstance()) >= 0 && MonetaryValue__compareTo_impl_w7ul1r(project.w7b_1, project.z7b_1) > 0 && MonetaryValue__compareTo_impl_w7ul1r(remainingEscrowDeposits, Companion_instance.m62(0)) > 0;
        });
        var tmp_10 = this;
        tmp_10.qgi_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.lfy()).u7b_1.d4(ProjectState_Complete_getInstance()) >= 0);
        var tmp_11 = this;
        tmp_11.rgi_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).sfv_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ProjectLedgerItem()), arrayOf([]), false));
          var tmp$ret$1 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$1);
          var tmp$ret$3 = and(and(eq(get_project(it), this.lf8()), eq(get_party(it), Party_Client_getInstance())), eq(get_state(it), PaymentState_AwaitingConfirmation_getInstance()));
          var tmp$ret$4 = new (Query())(tmp$ret$3, orderBy, 0, 100);
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var this_0 = $this$remember.daj(tmp.heo(tmp$ret$4));
          var sum = Companion_instance.r91(0n);
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp_1 = sum;
            var tmp$ret$5 = element.s7k_1;
            sum = MonetaryValue__plus_impl_c1ylt(tmp_1, tmp$ret$5);
          }
          var tmp$ret$6 = sum;
          return new (MonetaryValue())(_MonetaryValue___get_absoluteValue__impl__hjldkw(tmp$ret$6));
        });
        var tmp_12 = this;
        tmp_12.sgi_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp;
          if (this.tgj().equals(ProjectLens_Contractor_getInstance()) && $this$remember.daj(this.cgj_1).equals(ProjectState_AwaitingFunding_getInstance())) {
            var tmp0 = $this$remember.daj(this.vgj());
            var tmp$ret$7;
            $l$block_0: {
              // Inline function 'kotlin.collections.any' call
              var tmp_0;
              if (isInterface(tmp0, Collection())) {
                tmp_0 = tmp0.i1();
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                tmp$ret$7 = false;
                break $l$block_0;
              }
              var _iterator__ex2g4s = tmp0.m1();
              while (_iterator__ex2g4s.n1()) {
                var element = _iterator__ex2g4s.o1();
                if (element.j61_1 === Companion_instance.m62(0) && element.i61_1 === Companion_instance.m62(0)) {
                  tmp$ret$7 = true;
                  break $l$block_0;
                }
              }
              tmp$ret$7 = false;
            }
            tmp = tmp$ret$7;
          } else {
            tmp = false;
          }
          return tmp;
        });
        var tmp_13 = this;
        tmp_13.tgi_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var p = $this$remember.daj(this.lfy());
          return this.tgj().equals(ProjectLens_Contractor_getInstance()) && (p.u7b_1.equals(ProjectState_WaitingApproval_getInstance()) || p.u7b_1.equals(ProjectState_Invited_getInstance()));
        });
        var tmp_14 = this;
        tmp_14.ugi_1 = remember(VOID, VOID, VOID, ($this$remember) => isCancellable($this$remember.daj(this.cgj_1)) && MonetaryValue__compareTo_impl_w7ul1r($this$remember.daj(this.lfy()).a7c_1, Companion_instance.m62(0)) <= 0);
        var tmp_15 = this;
        tmp_15.vgi_1 = remember(VOID, VOID, VOID, ($this$remember) => this.tgj().equals(ProjectLens_Customer_getInstance()) && $this$remember.daj(this.lfy()).u7b_1.d4(ProjectState_Accepted_getInstance()) >= 0 && $this$remember.daj(this.ygi_1));
        var tmp_16 = this;
        tmp_16.wgi_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var p = $this$remember.daj(this.lfy());
          return this.tgj().equals(ProjectLens_Preview_getInstance()) && (p.u7b_1.equals(ProjectState_WaitingApproval_getInstance()) || p.u7b_1.equals(ProjectState_Invited_getInstance())) && !($this$remember.daj(get_rawSession()) == null);
        });
        this.xgi_1 = BasicListenable().paq();
        var tmp_17 = this;
        tmp_17.ygi_1 = rememberSuspending(VOID, VOID, VOID, ProjectView$needsPaymentMethods$slambda_0(this));
        var tmp_18 = this;
        tmp_18.zgi_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.daj(this.vgm());
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.g99() == null && requiresReview(this, element)) {
              destination.v(element);
            }
          }
          return destination;
        });
        var tmp_19 = this;
        tmp_19.agj_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var items = $this$remember.daj(this.zgi_1);
          var permissions = $this$remember.daj(this.ogf());
          // Inline function 'kotlin.collections.mapNotNull' call
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination = ArrayList().w();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = items.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp0_safe_receiver = permissions.p3(element.mf9_1);
            var tmp;
            if (tmp0_safe_receiver == null) {
              tmp = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp = to(element, tmp0_safe_receiver);
            }
            var tmp0_safe_receiver_0 = tmp;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination.v(tmp0_safe_receiver_0);
            }
          }
          return destination;
        });
        var tmp_20 = this;
        tmp_20.bgj_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.associateBy' call
          var this_0 = $this$remember.daj(this.ngy());
          var capacity = coerceAtLeast_0(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
          // Inline function 'kotlin.collections.associateByTo' call
          var destination = LinkedHashMap().fc(capacity);
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp$ret$21 = element.i7z_1;
            destination.s3(tmp$ret$21, element);
          }
          var lookup = destination;
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.daj(this.vgm());
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList().w();
          var _iterator__ex2g4s_0 = tmp0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            if (!(element_0.g99() == null) && requiresReview(this, element_0)) {
              destination_0.v(element_0);
            }
          }
          // Inline function 'kotlin.collections.groupBy' call
          // Inline function 'kotlin.collections.groupByTo' call
          var destination_1 = LinkedHashMap().f6();
          var _iterator__ex2g4s_1 = destination_0.m1();
          while (_iterator__ex2g4s_1.n1()) {
            var element_1 = _iterator__ex2g4s_1.o1();
            var key = element_1.g99();
            // Inline function 'kotlin.collections.getOrPut' call
            var value = destination_1.p3(key);
            var tmp;
            if (value == null) {
              var answer = ArrayList().w();
              destination_1.s3(key, answer);
              tmp = answer;
            } else {
              tmp = value;
            }
            var list = tmp;
            list.v(element_1);
          }
          // Inline function 'kotlin.collections.mapKeys' call
          // Inline function 'kotlin.collections.mapKeysTo' call
          var destination_2 = LinkedHashMap().fc(mapCapacity(destination_1.p1()));
          // Inline function 'kotlin.collections.associateByTo' call
          var _iterator__ex2g4s_2 = destination_1.d2().m1();
          while (_iterator__ex2g4s_2.n1()) {
            var element_2 = _iterator__ex2g4s_2.o1();
            // Inline function 'kotlin.collections.get' call
            var key_0 = element_2.e2();
            var tmp_0 = (isInterface(lookup, KtMap()) ? lookup : THROW_CCE()).p3(key_0);
            var tmp$ret$34 = element_2.f2();
            destination_2.s3(tmp_0, tmp$ret$34);
          }
          return filterNullKeys(destination_2);
        });
        var tmp_21 = this;
        tmp_21.cgj_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.lfy()).u7b_1);
        var tmp_22 = this;
        var tmp_23;
        if (this.tgj().equals(ProjectLens_Customer_getInstance())) {
          tmp_23 = remember(VOID, VOID, VOID, ($this$remember) => {
            // Inline function 'kotlin.collections.filter' call
            var tmp0 = $this$remember.daj(this.xgv());
            // Inline function 'kotlin.collections.filterTo' call
            var destination = ArrayList().w();
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (!(element.t57_1 == null)) {
                destination.v(element);
              }
            }
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
            var _iterator__ex2g4s_0 = destination.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var item = _iterator__ex2g4s_0.o1();
              var tmp$ret$41 = item.o57_1;
              destination_0.v(tmp$ret$41);
            }
            var published = destination_0;
            // Inline function 'kotlin.collections.filter' call
            var tmp0_0 = $this$remember.daj(this.kgt());
            // Inline function 'kotlin.collections.filterTo' call
            var destination_1 = ArrayList().w();
            var _iterator__ex2g4s_1 = tmp0_0.m1();
            while (_iterator__ex2g4s_1.n1()) {
              var element_0 = _iterator__ex2g4s_1.o1();
              if (get_pending(element_0) && published.t1(element_0.c72_1)) {
                destination_1.v(element_0);
              }
            }
            var tmp = destination_1;
            // Inline function 'kotlin.collections.filter' call
            var tmp0_1 = $this$remember.daj(this.lgt());
            // Inline function 'kotlin.collections.filterTo' call
            var destination_2 = ArrayList().w();
            var _iterator__ex2g4s_2 = tmp0_1.m1();
            while (_iterator__ex2g4s_2.n1()) {
              var element_1 = _iterator__ex2g4s_2.o1();
              if (get_pending(element_1) && published.t1(element_1.v75_1)) {
                destination_2.v(element_1);
              }
            }
            return plus(tmp, destination_2);
          });
        } else {
          tmp_23 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        }
        tmp_22.dgj_1 = tmp_23;
        var tmp_24 = this;
        var tmp_25;
        if (this.tgj().equals(ProjectLens_Customer_getInstance())) {
          tmp_25 = remember(VOID, VOID, VOID, ($this$remember) => {
            // Inline function 'kotlin.collections.map' call
            var this_0 = $this$remember.daj(this.dgj_1);
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s = this_0.m1();
            while (_iterator__ex2g4s.n1()) {
              var item = _iterator__ex2g4s.o1();
              var tmp$ret$50 = item.s94();
              destination.v(tmp$ret$50);
            }
            var pending = toSet(destination);
            // Inline function 'kotlin.collections.filter' call
            var tmp0 = $this$remember.daj(this.xgv());
            // Inline function 'kotlin.collections.filterTo' call
            var destination_0 = ArrayList().w();
            var _iterator__ex2g4s_0 = tmp0.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element = _iterator__ex2g4s_0.o1();
              if (pending.t1(element.o57_1)) {
                destination_0.v(element);
              }
            }
            return destination_0;
          });
        } else {
          tmp_25 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        }
        tmp_24.egj_1 = tmp_25;
        var tmp_26 = this;
        var tmp_27;
        if (this.tgj().equals(ProjectLens_Customer_getInstance())) {
          tmp_27 = remember(VOID, VOID, VOID, ($this$remember) => {
            var tmp = asSequence($this$remember.daj(this.jgt()));
            var tmp_0 = filter(tmp, ProjectView$pendingDraws$lambda$lambda);
            var pending = toSet_0(map(tmp_0, ProjectView$pendingDraws$lambda$lambda_0));
            // Inline function 'kotlin.collections.filter' call
            var tmp0 = $this$remember.daj(this.fgt());
            // Inline function 'kotlin.collections.filterTo' call
            var destination = ArrayList().w();
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (pending.t1(element.g6y_1)) {
                destination.v(element);
              }
            }
            return destination;
          });
        } else {
          tmp_27 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        }
        tmp_26.fgj_1 = tmp_27;
        this.ggj_1 = LateInitSignal().taq();
        var tmp_28 = this;
        tmp_28.hgj_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.ggj_1)));
        var tmp_29 = this;
        tmp_29.igj_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var perms = $this$remember.daj(this.ogf());
          // Inline function 'kotlin.collections.mapNotNull' call
          var tmp0 = $this$remember.daj(this.vgm());
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination = ArrayList().w();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp0_safe_receiver = perms.p3(element.mf9_1);
            var tmp;
            if (tmp0_safe_receiver == null) {
              tmp = null;
            } else {
              // Inline function 'kotlin.let' call
              var tmp0_safe_receiver_0 = requiresAction(tmp0_safe_receiver, true);
              var tmp_0;
              if (tmp0_safe_receiver_0 == null) {
                tmp_0 = null;
              } else {
                // Inline function 'kotlin.let' call
                tmp_0 = new (Triple())(element, tmp0_safe_receiver, tmp0_safe_receiver_0);
              }
              tmp = tmp_0;
            }
            var tmp0_safe_receiver_1 = tmp;
            if (tmp0_safe_receiver_1 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination.v(tmp0_safe_receiver_1);
            }
          }
          return destination;
        });
        var tmp_30 = this;
        tmp_30.jgj_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var perms = $this$remember.daj(this.tgt());
          // Inline function 'kotlin.collections.mapNotNull' call
          var tmp0 = $this$remember.daj(this.igt());
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination = ArrayList().w();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp0_safe_receiver = perms.p3(element.b63_1);
            var tmp;
            if (tmp0_safe_receiver == null) {
              tmp = null;
            } else {
              // Inline function 'kotlin.let' call
              var tmp0_safe_receiver_0 = requiresAction(tmp0_safe_receiver, true);
              var tmp_0;
              if (tmp0_safe_receiver_0 == null) {
                tmp_0 = null;
              } else {
                // Inline function 'kotlin.let' call
                tmp_0 = new (Triple())(element, tmp0_safe_receiver, tmp0_safe_receiver_0);
              }
              tmp = tmp_0;
            }
            var tmp0_safe_receiver_1 = tmp;
            if (tmp0_safe_receiver_1 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination.v(tmp0_safe_receiver_1);
            }
          }
          return destination;
        });
        var tmp_31 = this;
        tmp_31.kgj_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.daj(this.ogf()).r3();
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!element.s8x().i1()) {
              destination.v(element);
            }
          }
          var tmp = destination;
          // Inline function 'kotlin.collections.filter' call
          var tmp0_0 = $this$remember.daj(this.tgt()).r3();
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList().w();
          var _iterator__ex2g4s_0 = tmp0_0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!element_0.s8x().i1()) {
              destination_0.v(element_0);
            }
          }
          return plus(tmp, destination_0);
        });
        var tmp_32 = this;
        tmp_32.lgj_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var allPerms = $this$remember.daj(this.ogf());
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.daj(this.vgm());
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp0_safe_receiver = allPerms.p3(element.mf9_1);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s8x();
            if (hasConcernCard(element, tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs)) {
              destination.v(element);
            }
          }
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
          var _iterator__ex2g4s_0 = destination.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var item = _iterator__ex2g4s_0.o1();
            var tmp$ret$92 = item.mf9_1;
            destination_0.v(tmp$ret$92);
          }
          return toSet(destination_0);
        });
        var tmp_33 = this;
        tmp_33.mgj_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp;
          if (this.tgj().equals(ProjectLens_Contractor_getInstance())) {
            var tmp0_safe_receiver = $this$remember.daj(this.rgj_1);
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp_0 = tmp0_safe_receiver.d4(MemberRole_Manager_getInstance()) >= 0;
            }
            tmp = tmp_0 === true;
          } else {
            tmp = false;
          }
          return tmp;
        });
        var tmp_34 = this;
        tmp_34.ngj_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp;
          if (!this.tgj().equals(ProjectLens_Contractor_getInstance())) {
            tmp = true;
          } else {
            var tmp0_safe_receiver = $this$remember.daj(this.rgj_1);
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp_0 = tmp0_safe_receiver.d4(MemberRole_Manager_getInstance()) >= 0;
            }
            tmp = tmp_0 === true;
          }
          return tmp;
        });
        var tmp_35 = this;
        var tmp_36 = get_rawSession();
        tmp_35.ogj_1 = lens(tmp_36, (session) => {
          var tmp;
          if (session == null) {
            return emptyMap();
          }
          // Inline function 'kotlin.collections.associateWith' call
          var this_0 = get_entries_0();
          var result = LinkedHashMap().fc(coerceAtLeast_0(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
          // Inline function 'kotlin.collections.associateWithTo' call
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            // Inline function 'kotlin.collections.associateWith' call
            var this_1 = element.bjb_1;
            var result_0 = LinkedHashMap().fc(coerceAtLeast_0(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16));
            // Inline function 'kotlin.collections.associateWithTo' call
            var _iterator__ex2g4s_0 = this_1.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element_0 = _iterator__ex2g4s_0.o1();
              var tmp_0;
              if (equals(element_0, InfoSection_Ledger_getInstance())) {
                tmp_0 = Companion_getInstance_2().fft_1;
              } else if (equals(element_0, InfoSection_Contacts_getInstance())) {
                tmp_0 = Companion_getInstance_2().fft_1;
              } else if (equals(element_0, InfoSection_Details_getInstance())) {
                tmp_0 = session.bfw_1.if9(VOID, ($this$handle, it) => {
                  // Inline function 'kotlin.collections.filter' call
                  var tmp0 = $this$handle.daj(this.zgz());
                  // Inline function 'kotlin.collections.filterTo' call
                  var destination = ArrayList().w();
                  var _iterator__ex2g4s = tmp0.m1();
                  while (_iterator__ex2g4s.n1()) {
                    var element = _iterator__ex2g4s.o1();
                    if (element.d5p_1 == null) {
                      destination.v(element);
                    }
                  }
                  return destination;
                });
              } else if (equals(element_0, ActivitySection_ToDos_getInstance())) {
                tmp_0 = Companion_getInstance_2().fft_1;
              } else if (equals(element_0, ActivitySection_Concerns_getInstance())) {
                var tmp_1 = session.efw_1.if9(VOID, ($this$handle, it) => {
                  // Inline function 'kotlin.collections.filter' call
                  var tmp0 = $this$handle.daj(this.dgt());
                  // Inline function 'kotlin.collections.filterTo' call
                  var destination = ArrayList().w();
                  var _iterator__ex2g4s = tmp0.m1();
                  while (_iterator__ex2g4s.n1()) {
                    var element = _iterator__ex2g4s.o1();
                    if ($this$handle.daj(this.lgj_1).t1(element.y6g_1)) {
                      destination.v(element);
                    }
                  }
                  return destination;
                });
                var tmp_2 = tmp_1.ufw(session.jfw_1.if9(VOID, ($this$handle, it) => $this$handle.daj(this.egt())));
                var tmp_3 = tmp_2.ufw(session.gfw_1.if9(VOID, ($this$handle, it) => {
                  // Inline function 'kotlin.collections.filter' call
                  var tmp0 = $this$handle.daj(this.ggt());
                  // Inline function 'kotlin.collections.filterTo' call
                  var destination = ArrayList().w();
                  var _iterator__ex2g4s = tmp0.m1();
                  while (_iterator__ex2g4s.n1()) {
                    var element = _iterator__ex2g4s.o1();
                    if ($this$handle.daj(this.lgj_1).t1(element.q5d_1)) {
                      destination.v(element);
                    }
                  }
                  return destination;
                }));
                var tmp_4 = tmp_3.ufw(session.dfw_1.afu(VOID, ($this$handleFeedback, it) => $this$handleFeedback.daj(this.jgt())));
                var tmp_5 = tmp_4.ufw(session.vfv_1.afu(VOID, ($this$handleFeedback, it) => $this$handleFeedback.daj(this.kgt())));
                tmp_0 = tmp_5.ufw(session.ufv_1.afu(VOID, ($this$handleFeedback, it) => $this$handleFeedback.daj(this.lgt())));
              } else if (equals(element_0, ActivitySection_Messaging_getInstance())) {
                tmp_0 = session.lfw_1.if9(VOID, ($this$handle, it) => $this$handle.daj(this.kj3()));
              } else if (equals(element_0, WorkSection_Scope_getInstance())) {
                var tmp_6 = session.wfv_1.if9(VOID, ($this$handle, it) => $this$handle.daj(this.ngy()));
                var tmp_7 = tmp_6.ufw(session.ofv_1.if9(VOID, ($this$handle, it) => {
                  // Inline function 'kotlin.collections.map' call
                  var this_0 = $this$handle.daj(this.vgm());
                  // Inline function 'kotlin.collections.mapTo' call
                  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
                  var _iterator__ex2g4s = this_0.m1();
                  while (_iterator__ex2g4s.n1()) {
                    var item = _iterator__ex2g4s.o1();
                    var tmp$ret$108 = item.jf9_1;
                    destination.v(tmp$ret$108);
                  }
                  return destination;
                }));
                var tmp_8 = tmp_7.ufw(session.pfv_1.if9(VOID, ($this$handle, it) => {
                  // Inline function 'kotlin.collections.flatMap' call
                  var tmp0 = $this$handle.daj(this.vgm());
                  // Inline function 'kotlin.collections.flatMapTo' call
                  var destination = ArrayList().w();
                  var _iterator__ex2g4s = tmp0.m1();
                  while (_iterator__ex2g4s.n1()) {
                    var element = _iterator__ex2g4s.o1();
                    var list = element.lf9_1;
                    addAll(destination, list);
                  }
                  return destination;
                }));
                var tmp_9 = tmp_8.ufw(session.bfw_1.if9(VOID, ($this$handle, it) => {
                  // Inline function 'kotlin.collections.filter' call
                  var tmp0 = $this$handle.daj(this.zgz());
                  // Inline function 'kotlin.collections.filterTo' call
                  var destination = ArrayList().w();
                  var _iterator__ex2g4s = tmp0.m1();
                  while (_iterator__ex2g4s.n1()) {
                    var element = _iterator__ex2g4s.o1();
                    if (!(element.d5p_1 == null)) {
                      destination.v(element);
                    }
                  }
                  return destination;
                }));
                var tmp_10 = tmp_9.ufw(session.tfv_1.if9(VOID, ($this$handle, it) => {
                  // Inline function 'kotlin.collections.filter' call
                  var tmp0 = $this$handle.daj(this.wgm());
                  // Inline function 'kotlin.collections.filterTo' call
                  var destination = ArrayList().w();
                  var _iterator__ex2g4s = tmp0.m1();
                  while (_iterator__ex2g4s.n1()) {
                    var element = _iterator__ex2g4s.o1();
                    if (!(element.l7w_1 == null)) {
                      destination.v(element);
                    }
                  }
                  return destination;
                }));
                tmp_0 = tmp_10.ufw(session.ofv_1.mfu(VOID, VOID, ($this$handleCredits) => {
                  // Inline function 'kotlin.collections.map' call
                  var this_0 = $this$handleCredits.daj(this.vgm());
                  // Inline function 'kotlin.collections.mapTo' call
                  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
                  var _iterator__ex2g4s = this_0.m1();
                  while (_iterator__ex2g4s.n1()) {
                    var item = _iterator__ex2g4s.o1();
                    var tmp$ret$120 = item.jf9_1;
                    destination.v(tmp$ret$120);
                  }
                  return destination;
                }));
              } else if (equals(element_0, WorkSection_Tasks_getInstance())) {
                tmp_0 = session.tfv_1.if9(VOID, ($this$handle, it) => {
                  // Inline function 'kotlin.collections.filter' call
                  var tmp0 = $this$handle.daj(this.wgm());
                  // Inline function 'kotlin.collections.filterTo' call
                  var destination = ArrayList().w();
                  var _iterator__ex2g4s = tmp0.m1();
                  while (_iterator__ex2g4s.n1()) {
                    var element = _iterator__ex2g4s.o1();
                    if (element.l7w_1 == null) {
                      destination.v(element);
                    }
                  }
                  return destination;
                });
              } else if (equals(element_0, WorkSection_ChangeOrders_getInstance())) {
                var tmp_11 = session.jfv_1.if9(VOID, ($this$handle, it) => $this$handle.daj(this.xgv()));
                var tmp_12 = tmp_11.ufw(session.ufv_1.if9(VOID, ($this$handle, it) => $this$handle.daj(this.lgt())));
                tmp_0 = tmp_12.ufw(session.vfv_1.if9(VOID, ($this$handle, it) => $this$handle.daj(this.kgt())));
              } else if (equals(element_0, WorkSection_PayApps_getInstance())) {
                tmp_0 = session.cfw_1.if9(VOID, ($this$handle, it) => $this$handle.daj(this.fgt()));
              } else {
                noWhenBranchMatchedException();
              }
              var tmp$ret$126 = tmp_0;
              result_0.s3(element_0, tmp$ret$126);
            }
            result.s3(element, result_0);
          }
          return result;
        });
        var tmp_37 = this;
        tmp_37.pgj_1 = remember(VOID, true, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.associateWith' call
          var this_0 = get_entries_0();
          var result = LinkedHashMap().fc(coerceAtLeast_0(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
          // Inline function 'kotlin.collections.associateWithTo' call
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            // Inline function 'kotlin.collections.associateWith' call
            var this_1 = element.bjb_1;
            var result_0 = LinkedHashMap().fc(coerceAtLeast_0(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16));
            // Inline function 'kotlin.collections.associateWithTo' call
            var _iterator__ex2g4s_0 = this_1.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element_0 = _iterator__ex2g4s_0.o1();
              var tmp;
              if (equals(element_0, ActivitySection_Concerns_getInstance())) {
                // Inline function 'kotlin.collections.mapNotNull' call
                var tmp0 = $this$remember.daj(this.kgj_1);
                // Inline function 'kotlin.collections.mapNotNullTo' call
                var destination = ArrayList().w();
                // Inline function 'kotlin.collections.forEach' call
                var _iterator__ex2g4s_1 = tmp0.m1();
                while (_iterator__ex2g4s_1.n1()) {
                  var element_1 = _iterator__ex2g4s_1.o1();
                  var tmp0_safe_receiver = requiresAction(element_1, true);
                  if (tmp0_safe_receiver == null)
                    null;
                  else {
                    // Inline function 'kotlin.let' call
                    destination.v(tmp0_safe_receiver);
                  }
                }
                tmp = maxOrNull(destination);
              } else if (equals(element_0, WorkSection_Scope_getInstance())) {
                // Inline function 'kotlin.collections.mapNotNull' call
                var tmp0_0 = $this$remember.daj(this.ogf()).r3();
                // Inline function 'kotlin.collections.mapNotNullTo' call
                var destination_0 = ArrayList().w();
                // Inline function 'kotlin.collections.forEach' call
                var _iterator__ex2g4s_2 = tmp0_0.m1();
                while (_iterator__ex2g4s_2.n1()) {
                  var element_2 = _iterator__ex2g4s_2.o1();
                  var tmp0_safe_receiver_0 = requiresAction(element_2);
                  if (tmp0_safe_receiver_0 == null)
                    null;
                  else {
                    // Inline function 'kotlin.let' call
                    destination_0.v(tmp0_safe_receiver_0);
                  }
                }
                tmp = maxOrNull(destination_0);
              } else if (equals(element_0, WorkSection_ChangeOrders_getInstance())) {
                var tmp_0;
                var tmp_1;
                if (this.tgj().zgj()) {
                  // Inline function 'kotlin.collections.isNotEmpty' call
                  tmp_1 = !$this$remember.daj(this.dgj_1).i1();
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  tmp_0 = ActionImportance_Important_getInstance();
                } else {
                  tmp_0 = null;
                }
                tmp = tmp_0;
              } else if (equals(element_0, WorkSection_PayApps_getInstance())) {
                var tmp_2;
                var tmp_3;
                if (this.tgj().zgj()) {
                  var tmp0_1 = $this$remember.daj(this.jgt());
                  var tmp$ret$147;
                  $l$block_2: {
                    // Inline function 'kotlin.collections.any' call
                    var tmp_4;
                    if (isInterface(tmp0_1, Collection())) {
                      tmp_4 = tmp0_1.i1();
                    } else {
                      tmp_4 = false;
                    }
                    if (tmp_4) {
                      tmp$ret$147 = false;
                      break $l$block_2;
                    }
                    var _iterator__ex2g4s_3 = tmp0_1.m1();
                    while (_iterator__ex2g4s_3.n1()) {
                      var element_3 = _iterator__ex2g4s_3.o1();
                      if (element_3.z6v_1) {
                        tmp$ret$147 = true;
                        break $l$block_2;
                      }
                    }
                    tmp$ret$147 = false;
                  }
                  tmp_3 = tmp$ret$147;
                } else {
                  tmp_3 = false;
                }
                if (tmp_3) {
                  tmp_2 = ActionImportance_Important_getInstance();
                } else {
                  tmp_2 = null;
                }
                tmp = tmp_2;
              } else if (equals(element_0, ActivitySection_ToDos_getInstance())) {
                var tmp_5;
                // Inline function 'kotlin.collections.isNotEmpty' call
                if (!$this$remember.daj(this.hgj_1).i1()) {
                  tmp_5 = ActionImportance_Important_getInstance();
                } else {
                  tmp_5 = null;
                }
                tmp = tmp_5;
              } else {
                tmp = null;
              }
              var tmp$ret$150 = tmp;
              result_0.s3(element_0, tmp$ret$150);
            }
            result.s3(element, result_0);
          }
          return result;
        });
        var tmp_38 = this;
        var tmp_39 = mutableRemember(VOID, VOID, ($this$mutableRemember) => this.tgj().equals(ProjectLens_Preview_getInstance()) || $this$mutableRemember.daj(this.wgi_1) ? InfoSection_Ledger_getInstance() : WorkSection_Scope_getInstance());
        tmp_38.qgj_1 = interceptImmediateWrite(tmp_39, ProjectView$selectedSection$lambda);
        var tmp_40 = this;
        tmp_40.rgj_1 = remember(VOID, VOID, VOID, ProjectView$myMemberRole$lambda);
        this.sgj_1 = Signal().hak(null);
      }
      tgj() {
        return this.dgi_1;
      }
      xgl(_this__u8e3s4, $completion) {
      }
      sgm(_this__u8e3s4, $completion) {
      }
      pgm(_this__u8e3s4, $completion) {
      }
      ugj(key, getter) {
        // Inline function 'kotlin.collections.getOrPut' call
        var this_0 = this.egi_1;
        var value = this_0.p3(key);
        var tmp;
        if (value == null) {
          var answer = getter();
          this_0.s3(key, answer);
          tmp = answer;
        } else {
          tmp = value;
        }
        var tmp_0 = tmp;
        return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
      }
      wcv() {
        return this.fgi_1;
      }
      mj3(_this__u8e3s4, section) {
        var tmp0_safe_receiver = _this__u8e3s4.p3(section.xjc());
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p3(section);
      }
      nj3(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.scrolling' call
        // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
        var vertical = true;
        var horizontal = false;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
        var prev = _this__u8e3s4.dbb_1;
        var tmp = _this__u8e3s4;
        tmp.dbb_1 = (_this__u8e3s4_0) => {
          var tmp0_safe_receiver = prev;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4_0);
          (new (ScrollingBehaviorImpl())(_this__u8e3s4_0, horizontal, vertical)).qdj(get_viewIsWide(_this__u8e3s4));
          return Unit_instance;
        };
        Companion_getInstance_1();
        var tmp_0 = Companion_getInstance_1();
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        println('Rendering Project View');
        set_value(this.ggj_1, calculateTodos(this, view));
        launch(view, VOID, VOID, ProjectView$projectView$slambda_0(this));
        launch(view, VOID, VOID, ProjectView$projectView$slambda_2(this));
        registerJumpTos(this, view);
        // Inline function 'com.lightningkite.reactive.context.reactiveSuspending' call
        var action = ProjectView$projectView$slambda_4(this);
        // Inline function 'kotlin.also' call
        var this_0 = new (ReactiveContextSuspending())(view, VOID, VOID, action);
        this_0.aaj();
        var tmp0_safe_receiver = view.ga2().cd(Key_instance);
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.eah(this_0);
        }
        var tmp_1 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        view_0.bb9(get_AppDimensions().bg2_1);
        header(this, view_0);
        disputeBar(this, view_0);
        projectLevelMessages(this, view_0);
        var tmp_2 = view_0.kbb(shownWhen(view_0, VOID, ($this$shownWhen) => {
          var tmp;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!$this$shownWhen.daj(this.hgj_1).i1()) {
            tmp = $this$shownWhen.daj(this.ngj_1);
          } else {
            tmp = false;
          }
          return tmp;
        }), get_compact(view_0));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(false);
        view_1.lbb(get_centered(view_1), activityIcon(view_1));
        var tmp_3 = get_centered(view_1);
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (TextView())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.lba(view_2.qb6_1.abf(BodySemantic_getInstance()));
        var tmp_4 = KMutableProperty0();
        var tmp_5 = TextView$_get_content_$ref_4pzcwl(view_2);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb(view_2));
        reactiveScope(view_2, ($this$reactiveScope) => {
          var tmp$ret$9 = 'To-Do (' + $this$reactiveScope.daj(this.hgj_1).p1() + ") - You have required To-Do's";
          this_1.set(tmp$ret$9);
          return Unit_instance;
        });
        view_1.hbb(p_2, view_2);
        view_1.lbb(tmp_3, view_2);
        var tmp_6 = view_1.kbb(get_centered(view_1), get_textButton(view_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Button())(view_1.pc());
        var tmp0_elvis_lhs_3 = view_1.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
        view_1.gbb(p_3, view_3);
        bodyBold(view_3, 'View');
        onClick(view_3, VOID, VOID, ProjectView$projectView$slambda_6());
        view_1.hbb(p_3, view_3);
        view_1.lbb(tmp_6, view_3);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_2, view_1);
        actionBar2(this, view_0);
        if (this.tgj().equals(ProjectLens_Preview_getInstance())) {
          previewInformation(this, view_0);
        }
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_4 = view_0.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
        view_0.gbb(p_4, view_4);
        view_4.zbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.gbb(p_5, view_5);
        view_5.zbm(true);
        view_5.bb9(get_rem(0.2));
        var tmp_7 = view_5.jbb(OuterTabBar_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.gbb(p_6, view_6);
        view_6.zbm(false);
        var tmp_8 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.qgj_1).xjc());
        var selectedGroup = withWrite(tmp_8, ProjectView$projectView$slambda_8(this));
        var visibleGroups = remember(VOID, VOID, VOID, ($this$remember) => {
          var myRole = $this$remember.daj(this.rgj_1);
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = get_entries_0();
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp;
            if (this.tgj().zgj()) {
              tmp = true;
            } else {
              var tmp0_0 = element.bjb_1;
              var tmp$ret$23;
              $l$block_0: {
                // Inline function 'kotlin.collections.any' call
                var tmp_0;
                if (isInterface(tmp0_0, Collection())) {
                  tmp_0 = tmp0_0.i1();
                } else {
                  tmp_0 = false;
                }
                if (tmp_0) {
                  tmp$ret$23 = false;
                  break $l$block_0;
                }
                var _iterator__ex2g4s_0 = tmp0_0.m1();
                while (_iterator__ex2g4s_0.n1()) {
                  var element_0 = _iterator__ex2g4s_0.o1();
                  var tmp_1 = element_0.wjc();
                  if (tmp_1.d4(myRole == null ? MemberRole_Employee_getInstance() : myRole) <= 0) {
                    tmp$ret$23 = true;
                    break $l$block_0;
                  }
                }
                tmp$ret$23 = false;
              }
              tmp = tmp$ret$23;
            }
            if (tmp) {
              destination.v(element);
            }
          }
          return destination;
        });
        forEachUpdating(view_6, visibleGroups, VOID, ($this$forEachUpdating, group) => {
          var tmp;
          if (get_viewIsNarrow($this$forEachUpdating)) {
            get_expanding($this$forEachUpdating);
            tmp = Unit_instance;
          }
          // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
          var tmp_0 = $this$forEachUpdating.jbb(ButtonSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.radioToggleButton' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RadioToggleButton())($this$forEachUpdating.pc());
          var tmp0_elvis_lhs = $this$forEachUpdating.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
          $this$forEachUpdating.gbb(p, view);
          var content = (_this__u8e3s4) => {
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (RowOrCol())(_this__u8e3s4.pc());
            var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
            var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
            _this__u8e3s4.gbb(p, view);
            view.zbm(false);
            view.bb9(get_AppDimensions().og2_1);
            get_centered(view);
            unreadIconWhen(view, ($this$unreadIconWhen) => {
              var tmp0_safe_receiver = $this$unreadIconWhen.daj(this.ogj_1).p3($this$unreadIconWhen.daj(group));
              var tmp;
              if (tmp0_safe_receiver == null) {
                tmp = null;
              } else {
                var tmp$ret$29;
                $l$block_2: {
                  // Inline function 'kotlin.collections.any' call
                  if (tmp0_safe_receiver.i1()) {
                    tmp$ret$29 = false;
                    break $l$block_2;
                  }
                  // Inline function 'kotlin.collections.iterator' call
                  var _iterator__ex2g4s = tmp0_safe_receiver.d2().m1();
                  while (_iterator__ex2g4s.n1()) {
                    var element = _iterator__ex2g4s.o1();
                    if ($this$unreadIconWhen.daj(element.f2())) {
                      tmp$ret$29 = true;
                      break $l$block_2;
                    }
                  }
                  tmp$ret$29 = false;
                }
                tmp = tmp$ret$29;
              }
              var tmp1_elvis_lhs = tmp;
              return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
            });
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
            Companion_getInstance_1();
            var tmp = get_centered(view);
            view.lbb(tmp, actionIcon(view, VOID, ($this$actionIcon) => {
              var tmp0_safe_receiver = $this$actionIcon.daj(this.pgj_1).p3($this$actionIcon.daj(group));
              var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r3();
              var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : filterNotNull(tmp1_safe_receiver);
              var tmp;
              if (tmp2_safe_receiver == null) {
                tmp = null;
              } else {
                var tmp$ret$33;
                $l$block_4: {
                  // Inline function 'kotlin.collections.maxByOrNull' call
                  var iterator = tmp2_safe_receiver.m1();
                  if (!iterator.n1()) {
                    tmp$ret$33 = null;
                    break $l$block_4;
                  }
                  var maxElem = iterator.o1();
                  if (!iterator.n1()) {
                    tmp$ret$33 = maxElem;
                    break $l$block_4;
                  }
                  var maxValue = maxElem.mg1_1;
                  do {
                    var e = iterator.o1();
                    var v = e.mg1_1;
                    if (compareTo(maxValue, v) < 0) {
                      maxElem = e;
                      maxValue = v;
                    }
                  }
                   while (iterator.n1());
                  tmp$ret$33 = maxElem;
                }
                tmp = tmp$ret$33;
              }
              return tmp;
            }));
            var tmp_0 = get_centered(view);
            // Inline function 'com.crowpay.views.theming.body' call
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_0 = new (TextView())(view.pc());
            var tmp0_elvis_lhs_0 = view.ebb_1;
            var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
            view.gbb(p_0, view_0);
            view_0.lba(view_0.qb6_1.abf(BodySemantic_getInstance()));
            var tmp_1 = KMutableProperty0();
            var tmp_2 = TextView$_get_content_$ref_4pzcwl_0(view_0);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_0(view_0));
            reactiveScope(view_0, ($this$reactiveScope) => {
              var tmp$ret$36 = $this$reactiveScope.daj(group).ajb_1;
              this_0.set(tmp$ret$36);
              return Unit_instance;
            });
            view.hbb(p_0, view_0);
            view.lbb(tmp_0, view_0);
            _this__u8e3s4.hbb(p, view);
            return view;
          };
          if (get_viewIsNarrow(view))
            view.lbb(get_centered(view), content(view));
          else {
            specCenteredContent(view, VOID, ($this$specCenteredContent) => content($this$specCenteredContent));
          }
          view.zah(view.bc9_1, equalToDynamic(selectedGroup, ProjectView$projectView$lambda$slambda_0(group)));
          $this$forEachUpdating.hbb(p, view);
          $this$forEachUpdating.lbb(tmp_0, view);
          return Unit_instance;
        });
        view_5.hbb(p_6, view_6);
        view_5.lbb(tmp_7, view_6);
        var tmp_9 = colored(view_5, AppColors_getInstance().efz_1.zg9_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Separator())(view_5.pc());
        var tmp0_elvis_lhs_7 = view_5.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
        view_5.gbb(p_7, view_7);
        view_5.hbb(p_7, view_7);
        view_5.lbb(tmp_9, view_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view_5.pc());
        var tmp0_elvis_lhs_8 = view_5.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_5 : tmp0_elvis_lhs_8;
        view_5.gbb(p_8, view_8);
        view_8.zbm(false);
        var groupSections = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.let' call
          var tmp0 = $this$remember.daj(this.qgj_1).xjc().bjb_1;
          var tmp$ret$57;
          $l$block_5: {
            var tmp;
            if (this.tgj().zgj()) {
              tmp = tmp0;
            } else {
              var tmp0_elvis_lhs = $this$remember.daj(this.rgj_1);
              var tmp_0;
              if (tmp0_elvis_lhs == null) {
                tmp$ret$57 = emptyList();
                break $l$block_5;
              } else {
                tmp_0 = tmp0_elvis_lhs;
              }
              var role = tmp_0;
              // Inline function 'kotlin.collections.filter' call
              // Inline function 'kotlin.collections.filterTo' call
              var destination = ArrayList().w();
              var _iterator__ex2g4s = tmp0.m1();
              while (_iterator__ex2g4s.n1()) {
                var element = _iterator__ex2g4s.o1();
                if (element.wjc().d4(role) <= 0) {
                  destination.v(element);
                }
              }
              tmp = destination;
            }
            tmp$ret$57 = tmp;
          }
          // Inline function 'kotlin.collections.filter' call
          var tmp0_0 = tmp$ret$57;
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList().w();
          var _iterator__ex2g4s_0 = tmp0_0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            if ($this$remember.daj(this.lfy()).u7b_1.d4(element_0.yjc()) >= 0) {
              destination_0.v(element_0);
            }
          }
          return destination_0;
        });
        var tmp_10 = KMutableProperty0();
        var tmp_11 = RowOrCol$_get_shown_$ref_m8lfse(view_8);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_2 = getPropertyCallableRef('shown', 0, tmp_10, tmp_11, RowOrCol$_set_shown_$ref_7290m6(view_8));
        reactiveScope(view_8, ($this$reactiveScope) => {
          var tmp$ret$65 = $this$reactiveScope.daj(groupSections).p1() > 1;
          this_2.set(tmp$ret$65);
          return Unit_instance;
        });
        reactive(view_8, ($this$reactive) => {
          var tmp;
          if (!$this$reactive.daj(groupSections).t1($this$reactive.daj(this.qgj_1))) {
            // Inline function 'kotlin.takeUnless' call
            var this_0 = $this$reactive.daj(this.qgj_1).xjc().hjc($this$reactive.daj(this.rgj_1));
            var tmp_0;
            if (!!$this$reactive.daj(groupSections).t1(this_0)) {
              tmp_0 = this_0;
            } else {
              tmp_0 = null;
            }
            var tmp0_elvis_lhs = tmp_0;
            set_value(this.qgj_1, tmp0_elvis_lhs == null ? InfoSection_Ledger_getInstance() : tmp0_elvis_lhs);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        if (get_viewIsNarrow(view_8)) {
          get_expanding(view_8);
        }
        var tmp_12 = view_8.jbb(InnerTabBar_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (SwapView())(view_8.pc());
        var tmp0_elvis_lhs_9 = view_8.ebb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
        view_8.gbb(p_9, view_9);
        var sectionWithAction = interceptWrite(this.qgj_1, ProjectView$projectView$slambda_10(this));
        var prev_0 = {_v: null};
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        var this_3 = view_9;
        var queue = ArrayList().w();
        var alreadySwapping = {_v: false};
        reactiveScope(this_3, ($this$reactiveScope) => {
          var c = $this$reactiveScope.daj(groupSections);
          queue.v(c);
          var tmp;
          if (alreadySwapping._v) {
            return Unit_instance;
          }
          alreadySwapping._v = true;
          $l$loop: while (true) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!!queue.i1()) {
              break $l$loop;
            }
            var next = queue.z3(0);
            try {
              var tmp$ret$71;
              $l$block_7: {
                var tmp0_safe_receiver = firstOrNull(next);
                var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.xjc();
                var tmp_0;
                if (tmp1_elvis_lhs == null) {
                  tmp$ret$71 = Companion_getInstance_0().xax_1;
                  break $l$block_7;
                } else {
                  tmp_0 = tmp1_elvis_lhs;
                }
                var group = tmp_0;
                var cprev = prev_0._v;
                prev_0._v = group;
                if (cprev == null) {
                  tmp$ret$71 = Companion_getInstance_0().xax_1;
                  break $l$block_7;
                }
                tmp$ret$71 = group.d4(cprev) > 0 ? Companion_getInstance_0().tax_1 : Companion_getInstance_0().uax_1;
              }
              var tmp_1 = tmp$ret$71;
              this_3.tci(tmp_1, ProjectView$projectView$lambda$lambda(next, sectionWithAction, this));
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                report(Exception().vd('Failed to render ' + toString(next), e), 'SwapView.swapping');
              } else {
                throw $p;
              }
            }
          }
          alreadySwapping._v = false;
          return Unit_instance;
        });
        view_8.hbb(p_9, view_9);
        view_8.lbb(tmp_12, view_9);
        view_5.hbb(p_8, view_8);
        view_4.hbb(p_5, view_5);
        var tmp_13 = sizeConstraints(view_4, VOID, VOID, get_rem_0(35));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (Frame())(view_4.pc());
        var tmp0_elvis_lhs_10 = view_4.ebb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_4 : tmp0_elvis_lhs_10;
        view_4.gbb(p_10, view_10);
        var $this$frame = view_10;
        reactive($this$frame, ($this$reactive) => {
          $this$frame.bba();
          return $this$reactive.daj(this.qgj_1).vds()(this, $this$frame);
        });
        view_4.hbb(p_10, view_10);
        view_4.lbb(tmp_13, view_10);
        view_0.hbb(p_4, view_4);
        actionBar2(this, view_0);
        view.hbb(p_0, view_0);
        view.lbb(tmp_1, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp_0, view);
      }
      uhf(_this__u8e3s4) {
        return this.nj3(_this__u8e3s4);
      }
      hhg(_this__u8e3s4) {
        var tmp = sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        view.lbb(notificationBar(view, AppColors_getInstance().jfz_1), body(view, this.fhg()));
        _this__u8e3s4.hbb(p, view);
        _this__u8e3s4.lbb(tmp, view);
      }
    }
    protoOf($).dhg = get_requiredMembershipRole;
    protoOf($).ehg = get_finishRegistrationMessage;
    protoOf($).fhg = get_awaitingApprovalMessage;
    protoOf($).ghg = renderFinishRegistration;
    protoOf($).wd6 = render;
    initMetadataForClass($, 'ProjectView', VOID, VOID, [MightBeContractorPage()], [1]);
    ProjectViewClass = $;
  }
  return ProjectViewClass;
}
function ProjectLens_Contractor_getInstance() {
  ProjectLens_initEntries();
  return ProjectLens_Contractor_instance;
}
function ProjectLens_Customer_getInstance() {
  ProjectLens_initEntries();
  return ProjectLens_Customer_instance;
}
function ProjectLens_Preview_getInstance() {
  ProjectLens_initEntries();
  return ProjectLens_Preview_instance;
}
function ActionImportance_Important_getInstance() {
  ActionImportance_initEntries();
  return ActionImportance_Important_instance;
}
function ActionImportance_Critical_getInstance() {
  ActionImportance_initEntries();
  return ActionImportance_Critical_instance;
}
//region block: init
Companion_instance_5 = new (Companion_2())();
Buttons_instance = new (Buttons())();
//endregion
//region block: exports
export {
  get_entries as get_entries3gctu797fyfmn,
  ProjectLens as ProjectLens2yr68t3q88g3j,
  ProjectRouter as ProjectRouter1ifo7nf2si2jf,
  ProjectSection as ProjectSectionusf1qp9zg3nc,
  WorkSection as WorkSection1ye9ysnthnx95,
  ProjectView as ProjectView3mpzjwcpohxct,
  UnauthorizedLensException as UnauthorizedLensException1mhjkh9rtctj7,
  ActionImportance_Critical_getInstance as ActionImportance_Critical_getInstance3s0xptbpomhhd,
  ActionImportance_Important_getInstance as ActionImportance_Important_getInstance3s7qtcym9r8wq,
  ProjectLens_Contractor_getInstance as ProjectLens_Contractor_getInstance3hm6gxlnsv3ks,
  ProjectLens_Customer_getInstance as ProjectLens_Customer_getInstancedmuwwz4nvrem,
  ProjectLens_Preview_getInstance as ProjectLens_Preview_getInstance1ljkez32qkuib,
  RegisterAccountSection_Alerts_getInstance as RegisterAccountSection_Alerts_getInstance3g20s9j008qxo,
  RegisterAccountSection_Bank_getInstance as RegisterAccountSection_Bank_getInstance2xyzbaa4csj1z,
  RegisterAccountSection_Operations_getInstance as RegisterAccountSection_Operations_getInstance1glc4bqrncfkk,
  RegisterAccountSection_Owners_getInstance as RegisterAccountSection_Owners_getInstance2yh7pxrqx85w6,
  RegisterAccountSection_Profile_getInstance as RegisterAccountSection_Profile_getInstance1312jyno6l78y,
  RegisterAccountSection_Register_getInstance as RegisterAccountSection_Register_getInstance1xr8dfta5nyc0,
  RegisterAccountSection_Specs_getInstance as RegisterAccountSection_Specs_getInstance1nrs0n7t69eza,
  RegisterAccountSection_Users_getInstance as RegisterAccountSection_Users_getInstancesmklt5otzrhb,
  RegisterAccountSection_Verification_getInstance as RegisterAccountSection_Verification_getInstance1g2wlcm7n3sqb,
  WorkSection_Scope_getInstance as WorkSection_Scope_getInstance24nu4pcr0fu0d,
  assertViewerLens as assertViewerLens2aypbnpatof3k,
  Buttons_instance as Buttons_instancevdnfm4kr7aly,
};
//endregion

//# sourceMappingURL=ProjectView.mjs.map
